import {
  Paper,
  Grid2,
  Card,
  Typography,
  CardActionArea,
  Box,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import classes from "./css/products-list.module.css";
import * as services from "./../../services/saleng";
import { getLockSellProductId } from "../../utils/lockPricing";
import toast, { Toaster } from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Swal from "sweetalert2";
import ModernSwal from "../../utils/SwalUtils";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ScaleIcon from "@mui/icons-material/Scale";
import PrintIcon from "@mui/icons-material/Print";
import ImageIcon from "@mui/icons-material/Image";
import WeightDialog from "../../components/CarScaleDialog";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import CategoryIcon from "@mui/icons-material/Category";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DescriptionIcon from "@mui/icons-material/Description";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import GroupsIcon from "@mui/icons-material/Groups";
import LockIcon from "@mui/icons-material/Lock";
import ChecklistIcon from "@mui/icons-material/Checklist";
import PaymentDialog from "./components/pay_dialog";
import ImageModal from "../../components/ImageModal";
import { formatNumber } from "./../../utils/formatNumber";
import { generateInvoicePdfCopy } from "./components/generateInvoicePdfCopy";
import { generateInvoicePdf } from "./components/generateInvoicePdf";
import { generateInvoicePdfPo } from "./components/generateInvoicePdfPo";
import { getOrderedDeductionEntries } from "./components/deductionOrder";
import POSelectionDialog from "./components/POSelectionDialog";
import POBreakdownGrid from "./components/POBreakdownDialog";
import { green, grey, yellow } from "@mui/material/colors";
import CustomerPickerDialog from "../../components/CustomerPickerDialog";
import ProductFormDialog from "../../components/ProductFormDialog";
import Avatar from "@mui/material/Avatar";
import ItemTableModal from "../../components/ItemTableModal";
import Badge from "@mui/material/Badge";
import { getContrastColor } from "./../../utils/fontColor";
import { hasPermission } from "../../auth/RequirePermission3";
import TuneIcon from "@mui/icons-material/Tune";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import POExtraPriceDialog from "./components/POExtraPriceDialog";
import InsurancePriceDetailModal from "./components/InsurancePriceDetailModal";

const isSpacerCard = (card) => Boolean(card?.type === "spacer");

const createSpacerCard = (position) => ({
  type: "spacer",
  spacerId: `layout-spacer-${position}`,
});

const buildCardsWithSpacers = (layout, productMap) => {
  if (!Array.isArray(layout) || layout.length === 0) {
    return Object.values(productMap);
  }

  const sortedLayout = [...layout].sort(
    (a, b) => Number(a.position ?? 0) - Number(b.position ?? 0)
  );
  const cardsByPosition = new Map(
    sortedLayout.map((item) => [Number(item.position ?? 0), productMap[item.productId]])
  );
  const maxPosition = sortedLayout.reduce(
    (max, item) => Math.max(max, Number(item.position ?? 0)),
    -1
  );

  return Array.from({ length: maxPosition + 1 }, (_, index) => {
    const card = cardsByPosition.get(index);
    return card ?? createSpacerCard(index);
  });
};

const Page = ({ tabId, tabData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [cards, setCards] = useState([]);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [filter, setFilter] = useState("ทุกประเภท");
  const [subFilter, setSubFilter] = useState("ทั้งหมด");
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [imageDetail, setImageDetail] = useState([]);
  // const [products, setProducts] = useState([]);
  // dialogs
  const [openPOSelectionDialog, setOpenPOSelectionDialog] = useState(false);
  const [openTransactionDialog, setOpenTransactionDialog] = useState(false);
  const [openCustomerPickerDialog, setOpenCustomerPickerDialog] =
    useState(false);
  const [openPaymentMethod, setOpenPaymentMethod] = useState(false);
  const [openCarDialog, setOpenCarDialog] = useState(false);
  const [openImg, setOpenImg] = useState(false);
  const [openItemDialog, setOpenItemDialog] = useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);

  const [selectedValue, setSelectedValue] = useState([]);
  const [transaction, setTransaction] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null); // 'pay' or 'print'
  const isCanceled = transaction?.status === "cancel";
  const [lockSelect, setLockSelect] = useState([]);

  const [note, setNote] = useState();
  const [isWeighed, setIsWeighed] = useState(true);
  const [isPayed, setIsPayed] = useState(true);

  const query = useQuery();
  const transactionId = query.get("id");
  const debounceTimer = useRef(null);
  const fetchRequestId = useRef(0);

  const [poItems, setPoItems] = useState([]);
  const [poSelect, setPoSelect] = useState([]);
  const [lockItems, setLockItems] = useState([]);
  const [type, setType] = useState("");
  const [openPOExtraPriceDialog, setOpenPOExtraPriceDialog] = useState(false);
  const [selectedPOExtraItem, setSelectedPOExtraItem] = useState(null);
  const [openInsurancePriceDialog, setOpenInsurancePriceDialog] = useState(false);
  const [selectedInsuranceItem, setSelectedInsuranceItem] = useState(null);

  const [transactionBreakdown, setTransactionBreakdown] = useState([]);
  const [isLoadingBreakdown, setIsLoadingBreakdown] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [applying, setApplying] = useState(false);
  const [isBack, setIsBack] = useState(false);

  const N = (v) => Number(v ?? 0) || 0;
  const roundMoney = (v) =>
    Math.round((N(v) + Number.EPSILON) * 100) / 100;
  const PRICE_EPSILON = 0.005;
  const hasCustomerGroup = (tx = transaction) =>
    Boolean(tx?.customerGroupId) || Boolean(tx?.customer?.customerGroupId);
  const isAutoCategoryPricing = Boolean(transaction) && !hasCustomerGroup(transaction);
  const shouldAutoRepriceStepPricing = (tx = transaction) => !hasCustomerGroup(tx);

  const getPOPriceMeta = (item, productPrice, legacyPrice = 0) => {
    const basePrice = N(productPrice?.basePrice) + N(productPrice?.branchAdjustment);
    const groupPrice =
      N(productPrice?.finalPrice) ||
      (basePrice + N(productPrice?.groupAdjustment)) ||
      basePrice ||
      N(legacyPrice);

    const savedPrice = N(item?.pricePerUnit ?? legacyPrice);
    const explicitMode = item?.poExtraPriceMode ?? null;
    const customPrice = N(item?.poExtraCustomPrice ?? savedPrice);
    const inferredMode =
      explicitMode ||
      (Math.abs(savedPrice - basePrice) < PRICE_EPSILON
        ? "base"
        : Math.abs(savedPrice - groupPrice) < PRICE_EPSILON
          ? "group"
          : "custom");

    return {
      basePrice,
      groupPrice,
      customPrice,
      explicitMode,
      inferredMode,
      mode: inferredMode,
      savedPrice,
    };
  };

  const resolvePOExtraPrice = (item, productPrice, legacyPrice = 0) => {
    const meta = getPOPriceMeta(item, productPrice, legacyPrice);
    const mode = meta.explicitMode;

    if (mode === "base") return { ...meta, pricePerUnit: meta.basePrice };
    if (mode === "group") return { ...meta, pricePerUnit: meta.groupPrice };
    if (mode === "custom") return { ...meta, pricePerUnit: meta.customPrice };
    return { ...meta, pricePerUnit: N(legacyPrice) || meta.savedPrice };
  };

  const items = Array.isArray(transaction?.items) ? transaction?.items : [];
  // รวมจากรายการขาย
  const totalWeight = items.reduce((s, it) => s + N(it.weight), 0);
  const totalDeductWeight = items.reduce((s, it) => s + N(it.deductWeight), 0);
  const totalNetWeight = items.reduce((s, it) => s + N(it.netWeight), 0);
  const totalNetPrice = transaction?.totalNetPrice || 0;
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const scrollRef = useRef(null);

  const scrollToBottom = () => {
    const el = scrollRef.current;
    if (!el) return;
    requestAnimationFrame(() => {
      el?.scrollTo?.({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    });
  };

  useEffect(() => {
    const val = sessionStorage.getItem("SEARCH_AFTER_BACK");
    if (val) {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.set("search", val);

      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true },
      );

      sessionStorage.removeItem("SEARCH_AFTER_BACK");
    }
  }, [location.key, location.pathname, navigate]);

  useEffect(() => {
    scrollToBottom();
  }, [isLoadingBreakdown]);

  useEffect(() => {
    if (!transactionId) return;

    // ถ้า dialog เปิดอยู่ -> ไม่ fetch และไม่ตั้ง interval
    if (openPOSelectionDialog || openProductDialog) return;

    // เรียกครั้งแรกทันที
    fetchData();

    // แล้วค่อยตั้ง interval
    const timer = setInterval(() => {
      fetchData();
    }, 30000);

    // เคลียร์ทุกครั้งที่ transactionId / openPOSelectionDialog เปลี่ยน
    return () => clearInterval(timer);
  }, [transactionId, openPOSelectionDialog, openProductDialog]);

  // ฟังก์ชันคำนวณยอดรวมสุทธิหลัง repricing โดย “หัก PO ก่อน”
  function calcTotalAfterRepriceWithPO(tx, effectivePOItems, pricePayloads) {
    // map id ของ item -> ราคา/กก. ใหม่ (ที่เราจะตั้ง)
    const overridePPUMap = new Map(
      pricePayloads.map((p) => [p.id, N(p.pricePerUnit)]),
    );
    const round2 = (n) =>
      Math.round((n + Number.EPSILON) * 100) / 100;
    // ใช้ map เก็บว่า PO item ไหนถูกใช้ไปเท่าไหร่แล้วในการคำนวณรอบนี้
    const usedPOMap = new Map();
    let grandTotal = 0;

    for (const it of tx.items ?? []) {
      if (!it) continue;

      // น้ำหนักสุทธิของรายการ (ชั่ง - หักน้ำหนัก - สิ่งเจือปน - หักรายการอื่น)
      const impurityWeight =
        (it.impurities || []).reduce((s, i) => s + N(i.weight), 0) +
        (it.deductedItems || []).reduce((s, d) => s + N(d.weight2), 0);

      let remaining = N(it.weight) - N(it.deductWeight) - impurityWeight;

      // ดึง PO item ที่แมตช์สินค้านี้
      // effectivePOItems คือรายการ PO ที่ยังเหลือน้ำหนักให้ใช้ + ราคาต่อกก. (purchasePrice)
      const poForThisProduct = (effectivePOItems || [])
        .filter((po) => po.productId === it.productId)
        .sort((a, b) => {
          const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return ta - tb;
        });

      // ดึงราคา/กก. สุดท้ายที่จะใช้สำหรับ "ส่วนที่ไม่ได้ครอบด้วย PO"
      const overridePPU = overridePPUMap.get(it.id);
      const fallbackPPU = N(it.pricePerUnit); // ของเดิมในบิล
      const finalPPUForRemainder =
        overridePPU !== undefined ? overridePPU : fallbackPPU;

      // 1) ตัดน้ำหนักเข้า PO ก่อน
      for (const po of poForThisProduct) {
        if (remaining <= 0) break;

        const usedThisRun = N(usedPOMap.get(po.id));
        // ถ้า unlimitedWeight → ใช้ได้ไม่จำกัด
        const available = po.unlimitedWeight
          ? Infinity
          : Math.max(0, N(po.poWeight) - (N(po.actualWeight) + usedThisRun));

        if (available < 0) continue; // Allow 0 to record usage

        const take = available === 0
          ? 0
          : po.unlimitedWeight
            ? remaining
            : Math.min(remaining, available);

        grandTotal += round2(take * N(po.purchasePrice));

        usedPOMap.set(po.id, usedThisRun + take);
        remaining -= take;
      }

      // 2) น้ำหนักที่เหลือ คิดตามราคา group/branch (หลัง repricing)
      if (remaining !== 0) {
        grandTotal += round2(remaining * finalPPUForRemainder);
      }
    }

    return round2(grandTotal);

  }

  async function fetchData() {
    const requestId = ++fetchRequestId.current;
    const isLatestRequest = () => requestId === fetchRequestId.current;

    const pickTierByWeight = (prices = [], weight = 0) => {
      if (!Array.isArray(prices) || prices.length === 0)
        return { adjPrice: 0, minWeight: 0 };
      const sorted = [...prices].sort(
        (a, b) => (a.minWeight ?? 0) - (b.minWeight ?? 0),
      );
      let chosen = { adjPrice: 0, minWeight: 0 };
      for (const t of sorted) {
        if ((t.minWeight ?? 0) <= weight) chosen = t;
        else break;
      }
      return chosen;
    };

    try {
      setIsLoading(true);

      // 1) โหลด transaction
      const txRes = await services.getTransaction(transactionId);
      let tx = txRes?.data?.data ?? {};
      const txId = String(tx.tx ?? tx.transactionId ?? transactionId);

      // 2) โหลด products + layout พร้อมกัน
      const [productsRes, layoutRes] = await Promise.all([
        services.getProductsBranch(true, txId),
        services.getUserLayout(1),
      ]);
      const products = productsRes?.data?.data ?? [];
      const layout = layoutRes?.data ?? [];

      // setProducts(products);

      // เตรียมการ์ดสินค้าโชว์ใน UI
      const productMap = {};
      products.forEach((item) => {
        productMap[item.id] = {
          ...item,
          productId: item.id,
          categoryName: item.category?.name ?? "ไม่ระบุ",
          subCategoryName: item.subCategory?.name ?? "ไม่ระบุ",
          color: item.subCategory?.color ?? "royalblue",
        };
      });
      const box1Layout = layout.filter((l) => l.box === "box1");
      const sortedCards = buildCardsWithSpacers(box1Layout, productMap);

      if (!isLatestRequest()) return;

      setTransaction?.(tx);
      setIsWeighed?.(!!tx.isWeighed);
      setIsPayed?.(tx.status === "payed");
      setNote?.(tx.note ?? "");

      // สร้างรายชื่อหมวด
      const categoryMap = products
        .map((p) => p?.category)
        .filter(Boolean)
        .reduce((acc, cur) => {
          if (!acc.some((c) => c.id === cur.id)) acc.push(cur);
          return acc;
        }, []);
      const sortedCategories = categoryMap.sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0),
      );
      const categories = sortedCategories.map((c) => c.name);

      setCategories?.(categories);
      setCategories?.(categories);
      setCards?.(sortedCards);
      setData?.(sortedCards);

      // Restore or initialize category filter
      setFilter((prevFilter) => {
        const defaultCategory = categories.includes(prevFilter) && prevFilter !== "ทุกประเภท" ? prevFilter :
          (categories.length > 0 ? categories[0] : "ทุกประเภท");

        if (defaultCategory !== "ทุกประเภท") {
          const subs = sortedCards
            .filter(c => c.categoryName === defaultCategory)
            .map(c => c.subCategoryName)
            .filter(name => name && name !== "ไม่ระบุ");
          const uniqueSubs = [...new Set(subs)];
          setSubCategories(uniqueSubs);

          setSubFilter((prevSub) => uniqueSubs.includes(prevSub) ? prevSub : "ทั้งหมด");
        } else {
          const subs = sortedCards.map(c => c.subCategoryName).filter(name => name && name !== "ไม่ระบุ");
          const uniqueSubs = [...new Set(subs)];
          setSubCategories(uniqueSubs);

          setSubFilter((prevSub) => uniqueSubs.includes(prevSub) ? prevSub : "ทั้งหมด");
        }
        return defaultCategory;
      });

      // 3) โหลด PO / Lock / usage ที่เกี่ยวกับลูกค้าคนนี้ก่อน
      //    เพราะเราจะใช้มันคำนวณ totalNetPrice แบบรวมราคา PO
      let poItems = [];
      let lockItems = [];
      let effectivePOItems = [];

      if (tx?.customerId) {
        try {
          // ดึง PO ทั้งหมดของลูกค้าคนนี้ที่ยัง active ณ วันนี้
          const poData = await services.getPurchaseOrders({
            customerId: tx.customerId,
            currentDate: new Date().toISOString().split("T")[0],
          });
          poItems = poData ?? [];
        } catch (e) {
          console.warn("โหลด PO ล้มเหลว:", e);
        }

        try {
          // lock ราคาประจำลูกค้า (อันนี้ยังไม่ใช้รวมราคา แต่เก็บไว้เหมือนเดิม)
          const lockRes = await services.getLockPricingByCustomer(
            tx.customerId,
          );
          lockItems = (lockRes?.data || []).filter(
            (lock) =>
              String(lock?.master?.status || "").toUpperCase() === "APPROVED" &&
              !["CLOSED", "CANCELLED"].includes(
                String(lock?.status || "").toUpperCase(),
              ),
          );
        } catch (e) {
          console.warn("โหลด Lock ล้มเหลว:", e);
        }

        // สร้าง effectivePOItems จาก tx.poUsageJson + poItems
        const poFlat = (poItems ?? [])
          .flatMap((po) => (po.items ? po.items : [po]))
          .filter(Boolean);

        const poIndexByItemId = new Map(poFlat.map((it) => [it.id, it]));

        const usageList = Array.isArray(tx?.poUsageJson) ? tx.poUsageJson : [];

        effectivePOItems = usageList
          .map((u) => {
            const base = poIndexByItemId.get(u.poItemId);
            if (!base) return null;

            const remainActualWeight = Math.max(
              0,
              N(base.actualWeight) - N(u.usedWeight),
            );

            // ❌ ไม่เอา po รายการที่ไม่จำกัดที่ใช้แล้ว มาคิด
            if (base.unlimitedWeight === true && remainActualWeight > 0) {
              return null;
            }

            return {
              ...base,
              purchaseOrderId: u.poId,
              poNumber: u.poNumber,
              purchasePrice: N(u.purchasePrice),
              actualWeight: remainActualWeight,
            };
          })
          .filter(Boolean);
      }

      // 4) ถ้ายังไม่จ่ายเงิน → ทำ repricing
      //    - ถ้ามี group ใช้ราคากลุ่มตามเดิม
      //    - ถ้าไม่มีกลุ่ม ใช้ step pricing ของหมวดเสมอ แม้บิลจะเคย lock แล้ว
      if (tx.status !== "payed") {
        const hasGroup =
          Boolean(tx?.customerGroupId) ||
          Boolean(tx?.customer?.customerGroupId);
        const shouldAutoCategoryReprice = !hasGroup;

        const prodIndex = new Map(products.map((p) => [p.id, p]));
        const candidates = (tx.items || [])
          .filter((it) => it?.id && !it?.isLockedPrice)
          .map((it) => {
            const productId = it?.product?.id ?? it?.productId;
            const prod = prodIndex.get(productId);
            const base = N(prod?.basePrice ?? it?.product?.price);
            const branchAdj = N(prod?.branchAdjustment);
            const groupAdj = N(prod?.groupAdjustment);
            const currentPPU = N(it?.pricePerUnit);

            const finalFromProduct = hasGroup
              ? N(base + branchAdj + groupAdj)
              : N(base + branchAdj);

            // const candidatePPU = Math.max(currentPPU, finalFromProduct);
            const candidatePPU = finalFromProduct;

            return {
              id: it.id,
              item: it,
              productId,
              productPrice: prod,
              categoryId: it?.product?.categoryId ?? null,
              netW: N(it?.netWeight),
              base,
              currentPPU,
              finalFromProduct,
              candidatePPU,
            };
          });

        let pricePayloads = [];

        if (hasGroup) {
          // มี group → ไม่บวก tier หมวด
          pricePayloads = candidates.map((c) => {
            const resolved = resolvePOExtraPrice(c.item, c.productPrice, c.candidatePPU);
            const newPPU = resolved.pricePerUnit;
            const newNet = +(c.netW * newPPU).toFixed(2);

            return {
              id: c.id,
              pricePerUnit: newPPU,
              netPrice: newNet,
              basePricePerUnit: c.base,
              categoryAdjPrice: 0,
              tierMinWeight: null,
              appliedRule: "productFinalOnly_skipCategoryDueToGroup",
              poExtraPriceMode: resolved.mode,
              poExtraCustomPrice:
                resolved.mode === "custom"
                  ? resolved.customPrice
                  : N(c.item?.poExtraCustomPrice),
            };
          });
        } else if (shouldAutoCategoryReprice) {
          // ไม่มี group → ต้องบวกส่วนเพิ่มตาม tier หมวด
          const catRes = await services.getCategories();
          const categoryData = catRes?.data?.data ?? catRes?.data ?? [];

          // น้ำหนักรวมต่อหมวด
          const totalsByCat = new Map();
          for (const it of tx.items ?? []) {
            const catId = it?.product?.categoryId ?? null;
            if (!catId) continue;
            totalsByCat.set(
              catId,
              (totalsByCat.get(catId) || 0) + N(it?.netWeight),
            );
          }

          const catAdj = new Map();
          for (const [catId, totalNetW] of totalsByCat.entries()) {
            const cat = categoryData.find((c) => c?.id === catId);
            const tier = pickTierByWeight(cat?.prices, totalNetW);
            catAdj.set(catId, {
              adj: N(tier?.adjPrice),
              tierMin: tier?.minWeight ?? 0,
              totalNetW,
            });
          }

          pricePayloads = candidates.map((c) => {
            const entry = catAdj.get(c.categoryId) || {};
            const adj = entry.adj ?? 0;
            const currentPPU = c.candidatePPU + adj;
            const resolved = resolvePOExtraPrice(
              c.item,
              c.productPrice,
              currentPPU,
            );
            const newPPU = resolved.pricePerUnit;
            const newNet = +(c.netW * newPPU).toFixed(2);

            return {
              id: c.id,
              pricePerUnit: newPPU,
              netPrice: newNet,
              basePricePerUnit: c.base,
              categoryAdjPrice: adj,
              tierMinWeight: entry.tierMin ?? null,
              appliedRule: "productFinalThenCategoryAdd",
              poExtraPriceMode: resolved.mode,
              poExtraCustomPrice:
                resolved.mode === "custom"
                  ? resolved.customPrice
                  : N(c.item?.poExtraCustomPrice),
            };
          });
        }

        if (pricePayloads.length > 0) {
          // คำนวณยอดรวมสุทธิของทั้งบิลแบบรวมราคา PO ด้วย
          const totalNetPrice = calcTotalAfterRepriceWithPO(
            tx,
            effectivePOItems,
            pricePayloads,
          );
          console.log("totalNetPrice", totalNetPrice);
          await services.updateTransaction(
            {
              items: pricePayloads,
              totalNetPrice,
            },
            txId,
          );

          // รีเฟรช tx หลัง update
          const updatedTxRes = await services.getTransaction(txId);
          tx = updatedTxRes?.data?.data ?? {};
          if (!isLatestRequest()) return;
          setTransaction(tx);
        }
      }

      // 5) หลังจาก tx ถูกรีเฟรชแล้ว → คำนวณ breakdown สำหรับ UI เหมือนเดิม
      //    (ใช้ poItems / usage ในมือ ไม่ต้องยิงใหม่อีกรอบ)

      const usageList2 = Array.isArray(tx?.poUsageJson) ? tx.poUsageJson : [];
      const poFlat2 = (poItems ?? [])
        .flatMap((po) => (po.items ? po.items : [po]))
        .filter(Boolean);
      const poIndexByItemId2 = new Map(poFlat2.map((it) => [it.id, it]));
      const usageByItemId2 = new Map(usageList2.map((u) => [u.poItemId, u]));
      const usedHeadIds = [...new Set(usageList2.map((u) => u.poId))];

      const effectivePOItemsForUI = usageList2
        .map((u) => {
          const base = poIndexByItemId2.get(u.poItemId);
          if (!base) return null;
          return {
            ...base,
            purchaseOrderId: u.poId,
            poNumber: u.poNumber,
            purchasePrice: N(u.purchasePrice),
            actualWeight: Math.max(0, N(base.actualWeight) - N(u.usedWeight)),
          };
        })
        .filter(Boolean);

      const headIndex = new Map((poItems ?? []).map((h) => [h.id, h]));
      const poSelectForUI = usedHeadIds
        .map((hid) => headIndex.get(hid))
        .filter(Boolean)
        .map((head) => {
          const chosenItems = (head.items || [])
            .filter((it) => usageByItemId2.has(it.id))
            .map((it) => {
              const u = usageByItemId2.get(it.id);
              return {
                ...it,
                usedWeight: N(u?.usedWeight),
                total: N(u?.total ?? it.poWeight),
                purchasePrice: N(u?.purchasePrice ?? it.purchasePrice),
              };
            });
          return { ...head, items: chosenItems };
        });

      if (!isLatestRequest()) return;

      setPoItems?.(poItems);
      setLockItems?.(lockItems);
      setPoSelect?.(poSelectForUI);

      // 6) breakdownList → grouped → ensureAllItems (เหมือนเดิมของบิ๊ก)
      const productsIndex = new Map(products.map((p) => [p.id, p]));
      const findProduct = (pid) => productsIndex.get(pid) || null;

      const breakdownList = [];
      const usedPOMap2 = new Map();
      const locksById = new Map(
        (tx.items || []).flatMap((entry) => entry.lockPricings || [])
          .concat(lockItems || [])
          .filter((lock) => lock?.id)
          .map((lock) => [Number(lock.id), lock]),
      );

      (tx.items || []).forEach((item, index) => {
        const productPrice = findProduct(item.productId);

        const impurity =
          (item.impurities || []).reduce((s, i) => s + N(i.weight), 0) +
          (item.deductedItems || []).reduce((s, d) => s + N(d.weight2), 0);

        let remaining = N(item.weight) - N(item.deductWeight) - impurity;

        // ประกันราคาใช้เฉพาะ LockPricing ที่ผูกกับรายการนี้และวันที่ที่เลือก
        const selectedLockIds = Array.isArray(item.lockItemIds)
          ? item.lockItemIds
          : (item.lockPricings || []).map((lock) => lock.id);
        const matchingLocks = selectedLockIds
          .map((lockId) => locksById.get(Number(lockId)))
          .filter(
            (lock) =>
              lock &&
              getLockSellProductId(lock) === Number(item.productId) &&
              String(lock.status || "").toUpperCase() === "OPEN" &&
              (!lock.master ||
                String(lock.master.status || "").toUpperCase() === "APPROVED") &&
              lock.specialPrice != null,
          )
          .sort(
            (a, b) =>
              new Date(a.recordDate || 0).getTime() -
              new Date(b.recordDate || 0).getTime(),
          );

        // เก็บยอดของน้ำหนัก/ราคาที่ใช้ประกันไว้ใช้คำนวณราคาส่วนเกิน
        // เพราะ pricePerUnit ของรายการถูกเก็บเป็นราคาเฉลี่ยทั้งรายการ
        let lockedWeight = 0;
        let lockedTotal = 0;

        matchingLocks.forEach((lock) => {
          if (remaining <= 0) return;
          const availableWeight = N(lock.remainingWeight ?? lock.weight);
          const usedWeight = Math.min(remaining, availableWeight);
          if (usedWeight <= 0) return;

          const lockPrice = N(lock.specialPrice);
          lockedWeight += usedWeight;
          lockedTotal += usedWeight * lockPrice;
          breakdownList.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: lockPrice,
            poPricePerUnit: 0,
            totalPrice: usedWeight * lockPrice,
            usedWeight,
            priceSource: "lock",
            isLockedPrice: true,
            lockInfo: { ...lock },
            lockId: Number(lock.id),
            basePrice:
              N(productPrice?.basePrice) + N(productPrice?.branchAdjustment),
            groupPrice:
              N(productPrice?.finalPrice) ||
              (N(productPrice?.basePrice) + N(productPrice?.branchAdjustment)) ||
              N(item.pricePerUnit),
            finalPrice: productPrice?.finalPrice,
          });
          remaining -= usedWeight;
        });

        // ใช้ effectivePOItemsForUI ตรงนี้ในการแตก PO
        const matchingPO = (effectivePOItemsForUI || [])
          .filter((po) => po.productId === item.productId)
          .sort((a, b) => {
            const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
            const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
            return ta - tb;
          });

        matchingPO.forEach((po) => {
          if (remaining <= 0) return;
          const usedThisRun = N(usedPOMap2.get(po.id));
          const available = po.unlimitedWeight
            ? N(po.actualWeight) > 0
              ? 0 // เคยใช้แล้ว → ใช้ซ้ำไม่ได้
              : remaining // ยังไม่เคยใช้ → ใช้ได้ 1 ครั้ง
            : Math.max(0, N(po.poWeight) - (N(po.actualWeight) + usedThisRun));
          if (available < 0) return; // Only return if strictly negative, allow 0

          const take = available === 0
            ? 0 // Limit reached, take 0 but still record usage for UI badge
            : po.unlimitedWeight
              ? remaining
              : Math.min(remaining, available);

          breakdownList.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: 0,
            poPricePerUnit: N(po.purchasePrice),
            totalPrice: take * N(po.purchasePrice),
            usedWeight: take,
            priceSource: "po",
            poInfo: { ...po },
            basePrice:
              N(productPrice?.basePrice) + N(productPrice?.branchAdjustment),
            groupPrice: N(productPrice?.finalPrice) ||
              (N(productPrice?.basePrice) + N(productPrice?.branchAdjustment)) ||
              N(item.pricePerUnit),
            finalPrice: productPrice?.finalPrice,
            poExtraPriceMode: item?.poExtraPriceMode ?? null,
            poExtraCustomPrice: N(item?.poExtraCustomPrice),
          });

          usedPOMap2.set(po.id, usedThisRun + take);
          remaining -= take;
        });

        if (remaining !== 0) {
          const normalPrice =
            N(productPrice?.finalPrice) ||
            (N(productPrice?.basePrice) + N(productPrice?.branchAdjustment)) ||
            N(item.pricePerUnit);
          const isInsuranceItem = item.isLockedPrice && lockedWeight > 0;
          // เมื่อมีน้ำหนักส่วนเกิน ให้ถอดราคาที่ผู้ใช้เลือกไว้ออกจากราคาเฉลี่ย
          // ที่บันทึกในรายการ เพื่อให้ตารางแสดงราคาเดียวกับที่ใช้คำนวณจริง
          const storedAverage = N(item.pricePerUnit);
          const derivedInsuranceExtraPrice =
            isInsuranceItem && remaining > 0.004
              ? (storedAverage * N(item.netWeight ?? item.weight) - lockedTotal) /
                remaining
              : normalPrice;
          const insuranceExtraPrice = Number.isFinite(derivedInsuranceExtraPrice)
            ? Math.max(0, derivedInsuranceExtraPrice)
            : normalPrice;
          const hasPersistedInsuranceExtraPrice =
            isInsuranceItem && item.insuranceExtraPrice != null;
          const persistedInsuranceExtraPrice = hasPersistedInsuranceExtraPrice
            ? N(item.insuranceExtraPrice)
            : insuranceExtraPrice;
          const resolvedInsuranceExtraPrice = hasPersistedInsuranceExtraPrice
            ? persistedInsuranceExtraPrice
            : insuranceExtraPrice;
          const insuranceExtraMode = hasPersistedInsuranceExtraPrice
            ? item.insuranceExtraPriceMode || "custom"
            : Math.abs(resolvedInsuranceExtraPrice - normalPrice) < 0.005
              ? hasCustomerGroup(tx)
                ? "group"
                : "base"
              : "custom";
          const remainderResolved = isInsuranceItem
            ? {
                pricePerUnit: resolvedInsuranceExtraPrice,
                mode: insuranceExtraMode,
                customPrice: resolvedInsuranceExtraPrice,
              }
            : resolvePOExtraPrice(item, productPrice, N(item.pricePerUnit));
          const remainderPrice = remainderResolved.pricePerUnit;
          breakdownList.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: remainderPrice,
            poPricePerUnit: 0,
            totalPrice: remainderPrice * remaining,
            usedWeight: remaining,
            priceSource: remainderResolved.mode ?? "group",
            basePrice:
              N(productPrice?.basePrice) + N(productPrice?.branchAdjustment),
            groupPrice: N(productPrice?.finalPrice) ||
              (N(productPrice?.basePrice) + N(productPrice?.branchAdjustment)) ||
              N(item.pricePerUnit),
            finalPrice: productPrice?.finalPrice,
            isLockedPrice: false,
            customerGroupId: tx?.customer?.customerGroupId ?? null,
            poExtraPriceMode: remainderResolved.mode,
            poExtraCustomPrice: remainderResolved.customPrice,
          });
        }
      });

      const grouped = Object.values(
        breakdownList.reduce((acc, row) => {
          const key = row.index;
          const item = tx.items?.[row.index];
          const productPrice =
            (Array.isArray(products)
              ? products.find((p) => Number(p.id) === item?.productId)
              : null) || null;

          if (!acc[key]) {
            const impW =
              (item.impurities || []).reduce((s, i) => s + N(i.weight), 0) +
              (item.deductedItems || []).reduce((s, d) => s + N(d.weight2), 0);

            acc[key] = {
              index: row.index,
              finalPrice: productPrice?.finalPrice,
              customerId: tx.customerId,
              productId: row.productId,
              productName: row.productName,
              totalPrice: row.totalPrice || 0,
              usedWeight: row.usedWeight || 0,
              sources: [row.priceSource],
              details: [row],
              originalItem: item
                ? {
                  ...item,
                  netWeight: N(item.weight) - N(item.deductWeight) - impW,
                }
                : null,
            };
          } else {
            acc[key].totalPrice += row.totalPrice || 0;
            acc[key].usedWeight += row.usedWeight || 0;
            acc[key].sources.push(row.priceSource);
            acc[key].details.push(row);
          }
          return acc;
        }, {}),
      );

      // ensureAllItems: บรรทัดที่ไม่มี breakdown ก็ต้องโผล่
      const ensureAllItems = (tx.items || []).map((item, index) => {
        const found = grouped.find((g) => g.index === index);

        // Find parent item if it's a child (deducted as other product)
        const sourceItem = item.sourceItemId
          ? (tx.items || []).find((it) => it.id === item.sourceItemId)
          : null;

        if (found)
          return {
            ...found,
            originalItem: {
              ...found.originalItem,
              sourceItem,
            },
          };

        const productPrice =
          (Array.isArray(products)
            ? products.find((p) => Number(p.id) === item.productId)
            : null) || null;

        const impW =
          (item.impurities || []).reduce((s, i) => s + N(i.weight), 0) +
          (item.deductedItems || []).reduce((s, d) => s + N(d.netWeight), 0);
        const netWeight = N(item.weight) - N(item.deductWeight) - impW;

        return {
          index,
          finalPrice: productPrice?.finalPrice,
          customerId: tx.customerId,
          productId: item.productId,
          productName: item.productName,
          totalPrice: item.netPrice ?? (netWeight * (productPrice?.finalPrice || 0)),
          usedWeight: 0,
          sources: [],
          details: [],
          originalItem: { ...item, netWeight, sourceItem },
        };
      });

      if (!isLatestRequest()) return;

      setTransactionBreakdown(ensureAllItems);
      const calculatedTotalNetPrice = roundMoney(
        ensureAllItems.reduce((sum, item) => {
          const details = Array.isArray(item.details) ? item.details : [];
          const itemTotal = details.length
            ? details.reduce(
                (detailSum, detail) =>
                  detailSum + roundMoney(detail?.totalPrice),
                0,
              )
            : roundMoney(item.totalPrice);
          return sum + itemTotal;
        }, 0),
      );
      setTransaction((previous) =>
        previous
          ? { ...previous, totalNetPrice: calculatedTotalNetPrice }
          : previous,
      );
      setPoSelect?.(poSelectForUI);
      setLockItems?.(lockItems);
      setIsLoadingBreakdown(false);
      return ensureAllItems;
    } catch (error) {
      console.error("fetchData combined error:", error);
      return null;
    } finally {
      setIsLoading(false);
    }
  }

  const handleConfirm = async (data) => {
    // สร้าง images เฉพาะถ้ามี imageUrl
    const imageUrl = data?.imageUrl;
    const images = imageUrl ? [{ imageUrl: imageUrl, type: "img" }] : [];

    let payload = {
      carHeavyWeight: parseFloat(data?.heavy || 0),
      carLightWeight: parseFloat(data?.light || 0),
      ...(images.length > 0 && { images }), // ส่งเฉพาะถ้ามี
    };

    await services.updateTransaction(payload, transactionId);
    fetchData();
    setOpenCarDialog(false);
  };

  const handleChange = (value) => {
    setFilter(value);
    setSubFilter("ทั้งหมด");
    if (value === "ทุกประเภท") {
      const subs = data.map(c => c.subCategoryName).filter(name => name && name !== "ไม่ระบุ");
      setSubCategories([...new Set(subs)]);
    } else {
      const filteredProducts = data.filter((product) => {
        return product.categoryName === value;
      });
      const subs = filteredProducts.map(c => c.subCategoryName).filter(name => name && name !== "ไม่ระบุ");
      setSubCategories([...new Set(subs)]);
    }
  };

  const handleSubChange = (value) => {
    setSubFilter(value);
  };

  // Memoize displayed cards so it always updates accurately on state change
  const displayedCards = React.useMemo(() => {
    let result = data;
    if (filter !== "ทุกประเภท") {
      result = result.filter((card) => isSpacerCard(card) || card.categoryName === filter);
    }
    if (subFilter !== "ทั้งหมด") {
      result = result.filter((card) => isSpacerCard(card) || card.subCategoryName === subFilter);
    }
    return result;
  }, [data, filter, subFilter]);

  const handleSubmit = async (value) => {
    fetchRequestId.current += 1;

    const {
      title,
      id,
      weight,
      finalPrice,
      deduct,
      netWeight,
      impurities = [],
      itemId,
      deductedItems = [],
      note,
      isLockedPrice,
      snapshots = [],
    } = value;
    setOpenProductDialog(false);

    // ===== helpers =====
    const mapImgs = (arr = []) =>
      arr
        .filter((x) => x?.url)
        .map((x) => ({
          imageUrl: x.url,
          type: x?.label || x?.context?.type || "img",
          createdAt: x.at || null,
          meta: {
            at: x.at || null,
            label: x?.label || x?.context?.label,
            source: x?.context?.source,
            index: x?.context?.index,
            createdAt: x?.context?.createdAt,
            productId: x?.context?.productId,
            productName: x?.context?.productName,
            isDeductProduct: !!x?.context?.isDeductProduct,
          },
        }));

    // เก็บจำนวน items เดิมจาก state (transaction) เพื่อไว้เทียบ
    const prevCount = transaction?.items?.length ?? 0;

    const mainImages = mapImgs(snapshots);

    const _pricePerUnit = N(finalPrice);
    const _weight = N(weight);
    const _deductWeight = N(deduct);
    const _netWeight = N(netWeight);

    const totalImpurityWeight = (impurities || []).reduce(
      (sum, it) => sum + N(it?.weight),
      0,
    );

    const types = (impurities || [])
      .map((it) => it?.type || "")
      .filter(Boolean)
      .join(", ");
    const displayType = types ? `(${types})` : "";

    // แนบรูปที่มากับสิ่งเจือปนเท่านั้น
    const impuritiesWithImgs = (impurities || []).map((it) => ({
      ...it,
      weight: N(it?.weight),
      images: mapImgs(it?.attachedImages || it?.images || []),
    }));

    // ------- main item -------
    const mainItem = {
      id: itemId ?? undefined,
      productName: title ?? "",
      productId: id,
      pricePerUnit: _pricePerUnit,
      weight: _weight,
      deductWeight: _deductWeight,
      netWeight: _netWeight,
      netPrice: _netWeight * _pricePerUnit,
      note,
      isLockedPrice: Boolean(isLockedPrice),
      impurityWeight: totalImpurityWeight,
      impurities: impuritiesWithImgs,
      impurityType: displayType,
      ...(mainImages.length > 0 && { images: mainImages }),
    };

    try {
      const updatedItems = [
        ...(transaction?.items?.filter((it) => it.id !== mainItem.id) || []),
        mainItem,
      ];

      // คำนวณราคารวมใหม่
      const totalNetPrice = updatedItems.reduce(
        (sum, it) =>
          sum + Number(it.netWeight || 0) * Number(it.pricePerUnit || 0),
        0,
      );

      // (1) อัปเดตรายการหลัก
      const res = await services.updateTransaction(
        { items: [mainItem], totalNetPrice, hasWeighed: true, isLock: false },
        transactionId,
      );
      const updatedMainItem = res?.data?.data?.items?.[0];
      if (!updatedMainItem?.id) {
        toast.error("ไม่สามารถอัปเดตรายการหลักได้");
        return;
      }

      // (2) เตรียม deductedItems — แนบรูปเฉพาะที่ผูกกับแถว
      const additionalItems = (deductedItems || []).map((it) => {
        const w = N(it?.weight ?? it?.weight2);
        const p = N(it?.price ?? it?.pricePerUnit);
        const itemImgs = mapImgs(it?.attachedImages || it?.images || []);
        const isUpdate = !!it?.id;

        const base = {
          id: it?.id,
          sourceItemId: updatedMainItem.id,
          productName: it?.title ?? it?.productName ?? "",
          productId: it?.productId,
          pricePerUnit: p,
          createdAt: it?.createdAt,
          ...(itemImgs.length > 0 && { images: itemImgs }),
        };

        const defaultsForCreate = {
          isLockedPrice: false,
          deductWeight: 0,
          impurityWeight: 0,
          impurities: [],
          impurityType: "",
          usedWeight: null,
        };

        if (isUpdate) {
          return {
            ...base,
            weight2: w,
          };
        }
        return {
          ...base,
          ...defaultsForCreate,
          weight: w,
          weight2: w,
          netWeight: w,
          netPrice: w * p,
        };
      });

      // (3) สร้าง/อัปเดต deducted ที่เหลือ
      // หมายเหตุ: ไม่ลบรายการอัตโนมัติจาก diff ของ state เพื่อป้องกัน
      // item หายจากการรีเฟรช/แก้ไขไม่ครบ ข้อมูลจะถูกลบเฉพาะตอนกดปุ่มลบโดยตรง
      if (additionalItems.length > 0) {
        await services.updateTransaction(
          { items: additionalItems },
          transactionId,
        );
      }

      toast.success(`บันทึกรายการ ${title ?? ""} สำเร็จ`);
      setSelectedValue([]);

      // (4) ดึง transaction ล่าสุดมาเทียบจำนวน items ใหม่จริง ๆ
      const txRes2 = await services.getTransaction(transactionId);
      const txLatest = txRes2?.data?.data ?? {};
      setTransaction(txLatest);

      const newCount = txLatest?.items?.length ?? 0;
      const shouldAutoApplyBestPrice = shouldAutoRepriceStepPricing(txLatest);

      const hasNewItems = newCount > prevCount;

      if (shouldAutoApplyBestPrice) {
        await handleApplyBestPrice(txLatest);
      } else {
        // (5) รีเฟรช breakdown ตามปกติ
        await fetchData();
      }

      if (hasNewItems) {
        requestAnimationFrame(() => {
          scrollToBottom();
          setTimeout(scrollToBottom, 100);
        });
      }
    } catch (err) {
      console.error("เกิดข้อผิดพลาดในการอัปเดต transaction:", err);
      toast.error("ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const handleUpdate = async (value) => {
    const swalMessages = {
      isWeighed: "คุณแน่ใจว่าชั่งเสร็จแล้ว?",
      waiting: "คุณแน่ใจว่าจะยกเลิกการจ่ายเงิน?",
      cancel: "คุณแน่ใจว่าจะยกเลิกตั๋ว?",
      paid: "คุณแน่ใจว่าจ่ายแล้ว?",
      uncancel: "คุณแน่ใจว่าจะยกเลิกการยกเลิกบิล?",
    };

    const swalText = swalMessages[value] || "คุณแน่ใจว่าดำเนินการ?";

    Swal.fire({
      customClass: { container: "my-swal" },
      title: "ยืนยันการดำเนินการ",
      text: swalText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        if (value === "waiting") {
          // 1) โหลดบิลล่าสุด เพื่ออ่าน poUsageJson
          const txRes = await services.getTransaction(transactionId);
          const tx = txRes?.data?.data ?? {};
          const usage = Array.isArray(tx?.poUsageJson) ? tx.poUsageJson : [];

          // 2) รวม usedWeight ต่อ poItemId (กันแตกเป็นหลายดีเทลในบิลเดียว)
          const revertMap = usage.reduce((acc, u) => {
            const pid = N(u.poItemId);
            acc[pid] = (acc[pid] || 0) + N(u.usedWeight);
            return acc;
          }, {});

          // 3) ย้อนน้ำหนักกลับแต่ละ PO Item ด้วย delta ติดลบ
          const tasks = Object.entries(revertMap).map(([poItemIdStr, usedW]) =>
            services.adjustPurchaseOrderItemWeight(N(poItemIdStr), -N(usedW)),
          );
          if (tasks.length) await Promise.all(tasks);
          // 4) อัปเดตสถานะบิล + ล้าง usage
          await services.updateTransaction(
            {
              status: "waiting",
              paymentMethod: "",
              poUsageJson: null,
              hasPaid: false,
              paidAt: null,
            },
            transactionId,
          );
          let payload = {
            transactionId: tx.id,
            note: "ยกเลิก",
          };
          await services.cancelStock(payload);
          toast.success("ย้อนการจ่ายเงินและน้ำหนักเรียบร้อย");
          await fetchData();
          return;
        }

        // เคสอื่น ๆ
        let data;
        if (value === "isWeighed") {
          data = { isWeighed: !isWeighed };
        } else if (value === "close") {
          data = { status: "close" };
        } else if (value === "payed") {
          data = { status: "payed" };
        } else if (value === "uncancel") {
          data = { status: "waiting" };
        } else {
          data = { status: "cancel" };
        }

        await services.updateTransaction(data, transactionId);
        toast.success("บันทึกสำเร็จ");
        await fetchData();
      } catch (err) {
        console.error("handleUpdate error:", err);
        toast.error("เกิดข้อผิดพลาด");
      }
    });
  };

  const handleNoteChange = (e) => {
    const newNote = e.target.value;
    setNote(newNote);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      autoSaveNote(newNote);
    }, 1000);
  };

  const autoSaveNote = async (newNote) => {
    try {
      await services.updateTransaction({ note: newNote }, transactionId);
    } catch (err) {
      console.error("บันทึกหมายเหตุไม่สำเร็จ", err);
    }
  };

  const handleClose = async (value) => {
    setSelectedValue([]);
    setOpenProductDialog(false);
  };

  const handleDeleteItem = async (value) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: `ยืนยันที่จะลบ${value.productName} ?`,
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          await services.deleteItemTransaction(transactionId, value.id);
          toast.success(`ลบรายการ ${value.productName} สำเร็จ`);
        } catch (err) {
          console.log("err: ", err);
        } finally {
          const txRes = await services.getTransaction(transactionId);
          const txLatest = txRes?.data?.data ?? transaction;
          setTransaction(txLatest);

          if (shouldAutoRepriceStepPricing(txLatest)) {
            await handleApplyBestPrice(txLatest);
          } else {
            await fetchData();
          }
        }
      }
    });
  };

  const handleClick = (value) => {
    setOpenProductDialog(true);
    setSelectedValue(value);
  };

  const handleClickEdit = (value) => {
    const item = {
      categoryId: value?.product?.categoryId,
      itemId: value.id,
      title: value.productName,
      finalPrice: value.pricePerUnit,
      id: value.productId,
      weight: parseFloat(value.weight || 0),
      deduct: parseFloat(value.deductWeight || 0),
      netWeight: parseFloat(value.netWeight || 0),
      impurities: value.impurities,
      deductedItems: value.deductedItems,
      totalImpurityWeight: value.impurityWeight,
      note: value.note,
      value: value,
      customerId: transaction?.customerId,
    };
    setSelectedValue(item);
    setOpenProductDialog(true);
  };

  const handleOpenPOExtraPriceDialog = (item) => {
    setSelectedPOExtraItem(item);
    setOpenPOExtraPriceDialog(true);
  };

  const handleOpenInsurancePriceDialog = (item) => {
    setSelectedInsuranceItem(item);
    setOpenInsurancePriceDialog(true);
  };

  const handleSavePOExtraPrice = async (payload) => {
    if (!selectedPOExtraItem?.originalItem?.id) return;

    try {
      const itemId = selectedPOExtraItem.originalItem.id;
      const targetProductId = selectedPOExtraItem.originalItem.productId;
      await services.updateTransaction(
        {
          items: [
            {
              id: itemId,
              pricePerUnit: payload.pricePerUnit,
              poExtraPriceMode: payload.poExtraPriceMode || null,
              poExtraCustomPrice:
                payload.poExtraPriceMode === "custom"
                  ? payload.poExtraCustomPrice
                  : null,
            },
          ],
        },
        transactionId,
      );

      setOpenPOExtraPriceDialog(false);
      setSelectedPOExtraItem(null);
      const refreshedBreakdown = await fetchData();
      const updatedItem = Array.isArray(refreshedBreakdown)
        ? refreshedBreakdown.find(
            (row) =>
              row?.originalItem?.id === itemId ||
              row?.originalItem?.productId === targetProductId,
          )
        : null;
      if (updatedItem && openItemDialog) {
        setSelectedItem(updatedItem);
      }
      toast.success("บันทึกราคาส่วนเกิน PO แล้ว");
    } catch (err) {
      console.error("บันทึกราคาส่วนเกิน PO ไม่สำเร็จ:", err);
      toast.error("ไม่สามารถบันทึกราคาส่วนเกิน PO ได้");
    }
  };

  const handleSaveInsurancePrice = async (payload) => {
    if (!selectedInsuranceItem?.originalItem?.id) return;

    try {
      const itemId = selectedInsuranceItem.originalItem.id;
      const totalWeight = Number(
        payload.totalWeight ??
          selectedInsuranceItem.usedWeight ??
          selectedInsuranceItem.originalItem.netWeight ??
          0,
      ) || 0;
      const extraWeight = Number(payload.extraWeight || 0);
      const protectedTotal = Number(payload.protectedTotal || 0);
      const extraPrice = Number(payload.pricePerUnit || 0);
      const weightedPrice =
        totalWeight > 0
          ? (protectedTotal + extraWeight * extraPrice) / totalWeight
          : extraPrice;

      await services.updateTransaction(
        {
          items: [
            {
              id: itemId,
              pricePerUnit: weightedPrice,
              netPrice: protectedTotal + extraWeight * extraPrice,
              insuranceExtraPrice: extraPrice,
              insuranceExtraPriceMode: payload.priceMode || "custom",
              isLockedPrice: true,
            },
          ],
        },
        transactionId,
      );
      setOpenInsurancePriceDialog(false);
      setSelectedInsuranceItem(null);
      const refreshedBreakdown = await fetchData();
      const updatedItem = Array.isArray(refreshedBreakdown)
        ? refreshedBreakdown.find((row) => row?.originalItem?.id === itemId)
        : null;
      if (updatedItem && openItemDialog) setSelectedItem(updatedItem);
      toast.success("บันทึกราคาส่วนเกินประกันราคาแล้ว");
    } catch (err) {
      console.error("บันทึกราคาส่วนเกินประกันราคาไม่สำเร็จ:", err);
      toast.error("ไม่สามารถบันทึกราคาส่วนเกินประกันราคาได้");
    }
  };

  const generateLatestInvoicePdf = async (methodOverride = null) => {
    // โหลด breakdown ก่อน แล้วโหลด transaction ซ้ำหลัง fetchData เสร็จ
    // เพราะ fetchData อาจมีการ repricing และบันทึกข้อมูลลงฐานข้อมูล
    const latestBreakdown = await fetchData();
    if (!Array.isArray(latestBreakdown)) {
      throw new Error("ไม่สามารถโหลดข้อมูลรายการล่าสุดก่อนสร้าง PDF ได้");
    }

    const latestTxRes = await services.getTransaction(transactionId);
    const latestTx = latestTxRes?.data?.data ?? transaction;
    const method = methodOverride || latestTx?.paymentMethod || transaction?.paymentMethod;

    setTransaction?.(latestTx);
    setIsPayed?.(latestTx?.status === "payed");

    if (latestTx.shopId == 315) {
      generateInvoicePdfCopy(latestTx, method, latestBreakdown);
    } else if (
      latestTx.poUsageJson != null &&
      latestTx.poUsageJson.length !== 0
    ) {
      generateInvoicePdfPo(latestTx, latestBreakdown, method);
    } else {
      generateInvoicePdf(latestTx, method, latestBreakdown);
    }
  };

  const handleSelectMethod = async (method) => {
    if (selectedAction === "pay") {
      if (!requireTransportBeforePay()) {
        setSelectedAction(null);
        setOpenPaymentMethod(false);
        return;
      }

      await finalizePayment(method);
      setSelectedAction(null);
      return;
    }

    await services.updateTransaction(
      {
        paymentMethod: method,
      },
      transactionId,
    );

    await generateLatestInvoicePdf(method);

    setSelectedAction(null);
    if (isBack) window.history.back();
  };

  const hasSelectedTransport = () => {
    const hasCar = Boolean(transaction?.carId || transaction?.car?.id);
    const hasDriver = Boolean(transaction?.driverId || transaction?.driver?.id);
    return hasCar && hasDriver;
  };

  const requireTransportBeforePay = () => {
    if (hasSelectedTransport()) return true;

    ModernSwal.fire({
      title: "กรุณาเลือกข้อมูลให้ครบ",
      text: "ต้องเลือกรถและคนขับก่อนจ่ายเงิน",
      icon: "warning",
      confirmButtonText: "ตกลง",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
    });
    return false;
  };

  const handleOpenPDF = async () => {
    if (transaction?.status === "payed" && transaction?.paymentMethod) {
      try {
        await generateLatestInvoicePdf();
        return;
      } catch (err) {
        console.error("โหลด transaction ล่าสุดก่อนพิมพ์ไม่สำเร็จ:", err);
        toast.error("ไม่สามารถโหลดข้อมูลล่าสุดก่อนสร้าง PDF ได้");
      }
    }

    setSelectedAction("print");
    setOpenPaymentMethod(true);
  };

  const finalizePayment = async (method) => {
    try {
      const refreshedBreakdown = await fetchData();
      const paymentBreakdown = Array.isArray(refreshedBreakdown)
        ? refreshedBreakdown
        : transactionBreakdown;
      if (!Array.isArray(paymentBreakdown)) {
        throw new Error("ไม่สามารถคำนวณรายละเอียดราคาก่อนจ่ายเงินได้");
      }

      const latestTxRes = await services.getTransaction(transactionId);
      const paymentTransaction = latestTxRes?.data?.data ?? transaction;
      const paymentDate = new Date();
      const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      const paymentRecordDate = formatLocalDate(paymentDate);

      const paymentLockUsageMap = new Map();
      for (const group of paymentBreakdown) {
        for (const detail of group.details || []) {
          if (detail?.priceSource !== "lock" || !detail?.lockInfo?.id) {
            continue;
          }
          const lockId = Number(detail.lockInfo.id);
          const currentWeight = Number(paymentLockUsageMap.get(lockId) || 0);
          paymentLockUsageMap.set(
            lockId,
            currentWeight + N(detail.usedWeight),
          );
        }
      }
      const paymentLockUsage = Array.from(paymentLockUsageMap.entries()).map(
        ([lockId, weight]) => ({ lockId, weight }),
      );
      const paymentTotalNetPrice = roundMoney(
        paymentBreakdown.reduce((sum, group) => {
          const details = group.details || [];
          return (
            sum +
            (details.length
              ? details.reduce(
                  (detailSum, detail) => detailSum + N(detail.totalPrice),
                  0,
                )
              : N(group.totalPrice))
          );
        }, 0),
      );

      const poNumberByItemId = {};
      const poNumberByPoId = {};
      for (const po of poSelect || []) {
        if (po?.poNumber) poNumberByPoId[Number(po.id)] = String(po.poNumber);
        for (const it of po?.items || []) {
          if (it?.id && po?.poNumber) {
            poNumberByItemId[Number(it.id)] = String(po.poNumber);
          }
        }
      }

      // รวมแบบ "ต่อ PO Item"
      const updates = {}; // { [poItemId]: usedWeight รวม }
      const prices = {}; // { [poItemId]: ราคา/กก. }
      const itemHead = {}; // { [poItemId]: poId }

      for (const tx of paymentBreakdown || []) {
        const basePrice = N(tx?.basePrice);

        for (const d of tx.details || []) {
          const usedWeight = N(d?.usedWeight ?? d?.netWeight ?? d?.weight ?? 0);
          let pricePerUnit = N(d?.pricePerUnit ?? basePrice);
          // const predictPrice = N(d?.predictPrice ?? usedWeight * pricePerUnit);

          // จาก PO → อ้างอิง PO Item
          if (d?.priceSource === "po" && d?.poInfo) {
            pricePerUnit = N(
              d.poInfo.purchasePrice ??
              d.poPricePerUnit ??
              d.poPrice ??
              pricePerUnit,
            );
          }
          const netPrice = usedWeight * pricePerUnit;

          const predictPrice =
            d?.priceSource === "po" ? netPrice : N(d?.predictPrice ?? netPrice);
          d.pricePerUnit = pricePerUnit;
          d.netPrice = netPrice;
          d.predictPrice = predictPrice;
          if (d?.priceSource === "po" && d?.poInfo?.id) {
            const poItemId = N(d.poInfo.id);
            const poId =
              N(d.poInfo.purchaseOrderId ?? d.poInfo.poId ?? d.poId) || null;
            const poPrice = pricePerUnit;

            updates[poItemId] = N(updates[poItemId]) + usedWeight;
            prices[poItemId] = poPrice;
            if (poId != null) itemHead[poItemId] = poId;

            // กันเหนียว: ถ้า poInfo มี poNumber ก็เก็บลง map ด้วย
            if (!poNumberByItemId[poItemId] && d.poInfo?.poNumber) {
              poNumberByItemId[poItemId] = String(d.poInfo.poNumber);
            }
          }

        }
      }

      // เก็บประวัติราคาของสาขา Franchise ณ วันที่ทำรายการ
      try {
        const shopSnapshot = (await services.getShop())?.data?.data;
        const snapshotBranchId = Number(
          paymentTransaction?.customer?.customerBranchId ??
            paymentTransaction?.branchId ??
            localStorage.getItem("branchId"),
        );
        const currentShopId = Number(shopSnapshot?.id);
        const snapshotBranch = shopSnapshot?.branches?.find(
          (branch) => Number(branch.id) === snapshotBranchId,
        );
        if (
          shopSnapshot?.shopType === "FRANCHISE" &&
          snapshotBranch?.usePriceInsurance === true &&
          snapshotBranchId &&
          currentShopId
        ) {
          const snapshots = (paymentBreakdown || []).flatMap((tx) =>
            (tx.details || [])
              .filter((detail) => N(detail.usedWeight) > 0 && detail.productId)
              .map((detail) => ({
                productId: Number(detail.productId),
                branchId: snapshotBranchId,
                shopId: currentShopId,
                weight: N(detail.usedWeight),
                branchPrice: N(detail.pricePerUnit),
                headOfficePrice: N(detail.basePrice),
                recordDate: paymentRecordDate,
              }))
          );
          await Promise.all(snapshots.map((snapshot) => services.saveDailyPriceSnapshot(snapshot)));
        }
      } catch (snapshotError) {
        console.error("Daily Franchise price snapshot failed:", snapshotError);
      }

      if (paymentLockUsage.length > 0 && paymentTransaction?.shopId) {
        try {
          const branchId = Number(
            paymentTransaction?.customer?.customerBranchId ??
              paymentTransaction?.branchId ??
              localStorage.getItem("branchId"),
          );
          const lockCustomerId = Number(paymentTransaction?.customerId);
          await services.consumeLockPricing({
            shopId: Number(paymentTransaction.shopId),
            branchId,
            ...(Number.isFinite(lockCustomerId) &&
              lockCustomerId > 0 && { customerId: lockCustomerId }),
            allocations: paymentLockUsage,
          });
        } catch (lockError) {
          console.error("Consume insurance price failed:", lockError);
        }
      }

      // สร้าง poUsageJson (มี poId + poItemId + poNumber)
      const poUsage = Object.entries(updates).map(([poItemIdStr, usedW]) => {
        const poItemId = N(poItemIdStr);
        const purchasePrice = N(prices[poItemId] ?? 0);
        const total = N(usedW) * purchasePrice;
        const poId = itemHead[poItemId] ?? null;
        const poNumber =
          poNumberByItemId[poItemId] ??
          (poId != null ? poNumberByPoId[poId] : null) ??
          null;

        return {
          poId,
          poItemId,
          poNumber,
          usedWeight: N(usedW),
          purchasePrice,
          total,
        };
      });

      const poSnapshot = [];
      for (const po of poSelect || []) {
        for (const item of po?.items || []) {
          const poItemId = N(item?.id);
          if (!poItemId) continue;

          const usedWeight = N(updates[poItemId] ?? 0);
          const purchasePrice = N(item?.purchasePrice ?? 0);
          const actualWeightBefore = N(item?.actualWeight ?? 0);
          const actualWeightAfter = actualWeightBefore + usedWeight;

          poSnapshot.push({
            poId: N(po?.id ?? 0),
            poItemId,
            poNumber: String(po?.poNumber ?? ""),
            productId: N(item?.productId ?? item?.product?.id ?? 0),
            productName: item?.product?.title ?? item?.productName ?? "",
            subCategory: item?.product?.subCategory?.name ?? "",
            poWeight: N(item?.poWeight ?? 0),
            actualWeightBefore,
            actualWeightAfter,
            unlimitedWeight: !!item?.unlimitedWeight,
            usedWeight,
            purchasePrice,
            total: usedWeight * purchasePrice,
          });
        }
      }

      for (const [poItemId, usedW] of Object.entries(updates)) {
        await services.adjustPurchaseOrderItemWeight(N(poItemId), N(usedW));
      }
      const poPriceByItemId = Object.fromEntries(
        poUsage.map((u) => [u.poItemId, u.purchasePrice]),
      );

      for (const tx of paymentBreakdown || []) {
        const promises = tx.details.map((item) => {
          const poItemId = item?.poInfo?.id;
          const unitCost =
            poItemId && poPriceByItemId[poItemId]
              ? poPriceByItemId[poItemId]
              : (item?.pricePerUnit ?? 0);
          const payload = {
            productId: item.productId,
            quantity: item.usedWeight,
            unitCost,
            TransactionId: paymentTransaction.id,
            note: "ซื้อ",
          };
          //  console.log(payload)
          return services.updateStock(payload);
        });

        await Promise.all(promises);
      }
      // TransactionItem มีรายการจริง 1 รายการต่อ id จึงต้องรวมรายละเอียด
      // ราคา/น้ำหนักกลับเป็นรายการเดียวก่อนส่ง API ไม่ให้บรรทัดสุดท้ายทับบรรทัดก่อนหน้า
      const transactionItems = paymentBreakdown.flatMap((group) => {
        const details = group.details || [];
        const totalWeight = details.length
          ? details.reduce((sum, detail) => sum + N(detail.usedWeight), 0)
          : N(group.originalItem?.netWeight ?? group.originalItem?.weight);
        const totalPrice = roundMoney(
          details.length
            ? details.reduce((sum, detail) => sum + N(detail.totalPrice), 0)
            : N(group.totalPrice),
        );
        const originalWeight = N(
          group.originalItem?.netWeight ?? group.originalItem?.weight,
        );
        const weightedWeight = originalWeight || totalWeight;
        const weightedPrice =
          weightedWeight > 0 ? totalPrice / weightedWeight : 0;
        const lastDetail = details[details.length - 1] || {};

        return group.originalItem?.id
          ? [
              {
                id: group.originalItem.id,
                pricePerUnit: weightedPrice,
                netPrice: totalPrice,
                poExtraPriceMode: lastDetail.poExtraPriceMode ?? null,
                poExtraCustomPrice: lastDetail.poExtraCustomPrice ?? null,
                basePrice: lastDetail.basePrice,
                groupPrice: lastDetail.groupPrice,
              },
            ]
          : [];
      });

      const payload = {
        status: "payed",
        totalNetPrice: paymentTotalNetPrice,
        poUsageJson: poSnapshot.length > 0 ? poSnapshot : poUsage,
        hasPaid: true,
        paymentMethod: method,
        items: transactionItems,
      };
      if (paymentTransaction.weighedAt == null) {
        payload.weighedAt = paymentDate;
      }
      payload.paidAt = paymentDate;
      await services.updateTransaction(payload, transactionId);
      setIsBack(true);

      // Handle PDF generation after finalization
      await generateLatestInvoicePdf(method);
    } catch (e) {
      console.error("❌ update PO/LockPricing error:", e);
    }
  };

  const handlePayed = async () => {
    if (!isWeighed) {
      toast.error("กรุณาชั่งน้ำหนักให้เสร็จสิ้นก่อน");
      return;
    }

    if (!requireTransportBeforePay()) {
      return;
    }

    if (
      (poItems && poItems.length > 0 && (!poSelect || poSelect.length === 0)) ||
      transaction?.isLock === false
    ) {
      let htmlContent = "";

      // 🟡 เงื่อนไข 1: มีใบเสนอราคาแต่ยังไม่ได้เลือก
      if (
        poItems &&
        poItems.length > 0 &&
        (!poSelect || poSelect.length === 0)
      ) {
        htmlContent += `
      <div class="bg-amber-50 p-4 rounded-xl text-left border border-amber-100 mb-3">
        <div class="flex items-start gap-3">
          <div class="mt-0.5 text-amber-600 flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
              <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="text-amber-900 text-sm leading-relaxed">
            <p class="font-bold mb-1">มีใบเสนอราคา (PO) ที่สามารถใช้กับบิลนี้ได้</p>
            <p class="mb-1">กด <span class="font-bold text-red-600">"ยกเลิก"</span> เพื่อกลับไปเลือกใช้ใบเสนอราคา</p>
            <p>กด <span class="font-bold text-slate-700">"ทำรายการต่อไป"</span> หากต้องการจ่ายเงินโดยไม่ใช้ PO</p>
          </div>
        </div>
      </div>
    `;
      }

      // 🟠 เงื่อนไข 2: ยังไม่ได้กดใช้งานคำนวณราคา
      if (transaction?.isLock === false) {
        htmlContent += `
      <div class="bg-amber-50 p-4 rounded-xl text-left border border-amber-100">
        <div class="flex items-start gap-3">
          <div class="mt-0.5 text-amber-600 flex-shrink-0">
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
              <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="text-amber-900 text-sm leading-relaxed">
             <p class="font-bold mb-1">บิลนี้ยังไม่ได้คำนวณราคาดีที่สุด</p>
            <p class="mb-1">กด <span class="font-bold text-red-600">"ยกเลิก"</span> เพื่อกลับไปคำนวณราคาใหม่</p>
            <p>กด <span class="font-bold text-slate-700">"ทำรายการต่อไป"</span> หากต้องการจ่ายเงินทันที</p>
          </div>
        </div>
      </div>
    `;
      }
      htmlContent += "</div>"; // Close the flex container

      // 🔔 แสดง Swal เดียว (แต่มีหลายกล่องใน html ถ้าเข้า 2 เงื่อนไข)
      ModernSwal.fire({
        title: "โปรดตรวจสอบอีกครั้ง",
        html: htmlContent,
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ทำรายการต่อไป",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          setSelectedAction("pay");
          setOpenPaymentMethod(true);
        }
      });
    } else {
      setSelectedAction("pay");
      setOpenPaymentMethod(true);
    }
  };

  const [selectedImage, setSelectedImage] = useState([]);

  const handleChangeCustomer = async (customer) => {
    setOpenCustomerPickerDialog(false);

    const newCustomerId = customer?.customer?.id;

    const payload = {
      customerId: newCustomerId,
      customerName: customer?.customer?.name,
      carId: customer?.car?.id ?? null,
      driverId: customer?.driver?.id ?? null,
    };

    await services.updateTransaction(payload, transactionId);
    const txRes = await services.getTransaction(transactionId);
    const txLatest = txRes?.data?.data ?? transaction;
    setTransaction(txLatest);

    if (shouldAutoRepriceStepPricing(txLatest)) {
      await handleApplyBestPrice(txLatest);
      return;
    }

    await fetchData();
  };

  // --- VAT calc ---
  const VAT_RATE = 0.07;
  const taxOption = transaction?.customer?.purchaseTaxOption; // 'vatExcluded' | 'vatIncluded' | (อื่นๆ = ไม่มี VAT)

  const baseAmountRaw = totalNetPrice;

  let beforeVat, vatAmt, grand;

  if (taxOption === "vatExcluded") {
    // ราคา "ยังไม่รวม VAT" => เอา VAT บวกเข้าไป
    beforeVat = baseAmountRaw;
    vatAmt = beforeVat * VAT_RATE;
    grand = beforeVat + vatAmt;
  } else if (taxOption === "vatIncluded") {
    // ราคา "รวม VAT มาแล้ว" => ดึง VAT ออก
    grand = baseAmountRaw;
    vatAmt = (grand * VAT_RATE) / (1 + VAT_RATE);
    beforeVat = grand - vatAmt;
  } else {
    // ไม่มี VAT
    beforeVat = baseAmountRaw;
    vatAmt = 0;
    grand = beforeVat;
  }

  function summarizeDeductions() {
    const items = transaction?.items || [];

    const sumDeducted = items
      .flatMap((it) => it.deductedItems || [])
      .reduce((s, d) => s + (Number(d.weight) || 0), 0);

    let sumDiscard = 0,
      sumReturn = 0,
      sumConvert = 0;

    for (const it of items) {
      for (const im of it.impurities || []) {
        const w = Number(im.weight) || 0;
        const kind = im.kind || "discard"; // ถ้าไม่มี kind ให้ถือว่าเป็น "หักทิ้ง"

        if (kind === "discard") {
          sumDiscard += w;
        } else if (kind === "return") {
          sumReturn += w;
        } else if (kind === "convert") {
          sumConvert += w;
        }
      }
    }

    const parts = [];
    if (sumDeducted > 0)
      parts.push(`หักเป็นสินค้าอื่น ${formatNumber(sumDeducted)}`);
    if (sumDiscard > 0) parts.push(`หักทิ้ง ${formatNumber(sumDiscard)}`);
    if (sumReturn > 0) parts.push(`หักคืน ${formatNumber(sumReturn)}`);
    if (sumConvert > 0)
      parts.push(`แปลงเป็นสินค้าอื่น ${formatNumber(sumConvert)}`);

    return parts.length > 0 ? `(${parts.join(", ")})` : "";
  }

  const handleWeight = async () => {
    try {
      setIsLoading(true);
      // จะบันทึก isWeighed เสมอ
      const payload = { isWeighed: !isWeighed };

      await services.updateTransaction(payload, transactionId);
      await fetchData();
    } catch (err) {
      console.error("handleApplyBestPrice error:", err);
    } finally {
      await fetchData();
      setIsLoading(false);
    }
  };

  const handleApplyBestPrice = async (txOverride = transaction) => {
    const tx = txOverride ?? transaction;
    setApplying(true);
    try {
      const num = (v) => Number(v ?? 0) || 0;
      const txId = tx?.id ?? transactionId;
      const hasGroup = hasCustomerGroup(tx);

      let effectivePOItems = [];
      try {
        if (tx?.customerId) {
          const poData = await services.getPurchaseOrders({
            customerId: tx.customerId,
            currentDate: new Date().toISOString().split("T")[0],
          });
          const poItems = poData ?? [];

          const poFlat = (poItems ?? [])
            .flatMap((po) => (po.items ? po.items : [po]))
            .filter(Boolean);

          const poIndexByItemId = new Map(poFlat.map((it) => [it.id, it]));

          const usageList = Array.isArray(tx?.poUsageJson)
            ? tx.poUsageJson
            : [];

          effectivePOItems = usageList
            .map((u) => {
              const base = poIndexByItemId.get(u.poItemId);
              if (!base) return null;
              return {
                ...base,
                purchaseOrderId: u.poId,
                poNumber: u.poNumber,
                purchasePrice: num(u.purchasePrice),
                actualWeight: Math.max(
                  0,
                  num(base.actualWeight) - num(u.usedWeight),
                ),
              };
            })
            .filter(Boolean);
        }
      } catch (e) {
        console.warn(
          "สร้าง effectivePOItems ใน handleApplyBestPrice ล้มเหลว:",
          e,
        );
      }

      const items = tx?.items ?? [];
      let payloadItems = [];

      if (!hasGroup) {
        let products = [];
        try {
          const productsRes = await services.getProductsBranch(true, txId);
          products = productsRes?.data?.data ?? [];
        } catch (e) {
          console.warn("โหลดรายการสินค้าเพื่อคำนวณราคาขั้นบันไดไม่สำเร็จ:", e);
        }

        const productMap = new Map(products.map((p) => [Number(p.id), p]));
        const candidates = items
          .filter((it) => it?.id && it?.productId && !it?.isLockedPrice)
          .map((it) => {
            const productId = Number(it.productId);
            const prod = productMap.get(productId) ?? it?.product ?? null;
            const base = num(prod?.basePrice ?? prod?.price ?? it?.product?.price);
            const branchAdj = num(prod?.branchAdjustment);
            const categoryId = prod?.categoryId ?? it?.product?.categoryId ?? null;

            return {
              id: it.id,
              item: it,
              productId,
              categoryId,
              netW: num(it?.netWeight),
              basePPU: base + branchAdj,
              productPrice: prod,
            };
          });

        const catRes = await services.getCategories();
        const categoryData = catRes?.data?.data ?? catRes?.data ?? catRes ?? [];

        const totalsByCat = new Map();
        for (const it of items) {
          const catId = it?.product?.categoryId ?? null;
          if (!catId) continue;
          totalsByCat.set(
            catId,
            (totalsByCat.get(catId) || 0) + num(it?.netWeight),
          );
        }

        const pickTierByWeight = (prices = [], weight = 0) => {
          if (!Array.isArray(prices) || prices.length === 0)
            return { adjPrice: 0, minWeight: 0 };
          const sorted = [...prices].sort(
            (a, b) => (a.minWeight ?? 0) - (b.minWeight ?? 0),
          );
          let chosen = { adjPrice: 0, minWeight: 0 };
          for (const t of sorted) {
            if ((t.minWeight ?? 0) <= weight) chosen = t;
            else break;
          }
          return chosen;
        };

        const catAdj = new Map();
        for (const [catId, totalNetW] of totalsByCat.entries()) {
          const cat = categoryData.find((c) => c?.id === catId);
          const tier = pickTierByWeight(cat?.prices, totalNetW);
          catAdj.set(catId, {
            adj: num(tier?.adjPrice),
            tierMin: tier?.minWeight ?? 0,
          });
        }

        payloadItems = candidates.map((c) => {
          const entry = catAdj.get(c.categoryId) || {
            adj: 0,
            tierMin: null,
          };
          const legacyPPU = c.basePPU + (entry.adj || 0);
          const resolved = resolvePOExtraPrice(c.item, c.productPrice, legacyPPU);
          const ppu = resolved.pricePerUnit;
          const netPrice = +(c.netW * ppu).toFixed(2);

          return {
            id: c.id,
            pricePerUnit: ppu,
            netPrice,
            categoryAdjPrice: entry.adj || 0,
            tierMinWeight: entry.tierMin ?? null,
            appliedRule: "bestHistoryThenCategoryAdd",
            poExtraPriceMode: resolved.mode,
            poExtraCustomPrice:
              resolved.mode === "custom" ? resolved.customPrice : N(c.item?.poExtraCustomPrice),
          };
        });
      } else {
        let baselineByProductId = new Map();
        if (isWeighed) {
          const resData = await services.getBestPrice(txId);
          const perItem = Array.isArray(resData?.bestHistory?.perItem)
            ? resData.bestHistory.perItem
            : [];
          baselineByProductId = new Map(
            perItem.map((p) => {
              const ppu = num(p?.finalPrice ?? p?.basePrice);
              return [Number(p?.productId), ppu];
            }),
          );
        }

        const candidates = items
          .filter(
            (it) =>
              it?.id &&
              it?.productId &&
              !it?.isLockedPrice &&
              baselineByProductId.has(Number(it.productId)),
          )
          .map((it) => {
            const ppu = baselineByProductId.get(Number(it.productId)) || 0;
            return {
              id: it.id,
              item: it,
              productId: Number(it.productId),
              categoryId: it?.product?.categoryId ?? null,
              netW: num(it?.netWeight),
              basePPU: ppu,
              productPrice: it?.product ?? null,
            };
          });

        payloadItems = candidates.map((c) => {
          const resolved = resolvePOExtraPrice(c.item, c.productPrice, c.basePPU);
          const ppu = resolved.pricePerUnit;
          const netPrice = +(c.netW * ppu).toFixed(2);
          return {
            id: c.id,
            pricePerUnit: ppu,
            netPrice,
            categoryAdjPrice: 0,
            tierMinWeight: null,
            appliedRule: "bestHistoryOnly_skipCategoryDueToGroup",
            poExtraPriceMode: resolved.mode,
            poExtraCustomPrice:
              resolved.mode === "custom" ? resolved.customPrice : N(c.item?.poExtraCustomPrice),
          };
        });
      }

      let totalNetPrice = 0;
      if (payloadItems.length > 0) {
        totalNetPrice = calcTotalAfterRepriceWithPO(
          tx,
          effectivePOItems,
          payloadItems,
        );
      } else {
        totalNetPrice = (tx.items || []).reduce((sum, it) => {
          return sum + num(it.netWeight) * num(it.pricePerUnit);
        }, 0);
        totalNetPrice = +totalNetPrice.toFixed(2);
      }
      const payload = {
        isLock: true,
        totalNetPrice: totalNetPrice,
      };
      if (payloadItems.length > 0) {
        payload.items = payloadItems;
      }

      await services.updateTransaction(payload, transactionId);

      await fetchData();
    } catch (err) {
      console.error("handleApplyBestPrice error:", err);
    } finally {
      setApplying(false);
    }
  };

  const gridSizing = [5, 1.6, 5.4];

  return (
    <div className="h-screen bg-gray-50/30 flex flex-col overflow-hidden">
      <div className="p-4 pb-0 flex-none">
        <Toaster position="bottom-left" reverseOrder={false} />
        <AppBreadcrumbs />
      </div>

      <div className="flex-1 min-h-0 grid grid-cols-12 gap-6 p-4">
        {/* Column 1: Transaction & Summary */}
        <div className="col-span-12 lg:col-span-6 xl:col-span-6 flex flex-col min-h-0 bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
          {/* Header: Customer Info (Compact 2-Line Style) */}
          {transaction && (
            <div className="p-3 border-b border-gray-100 bg-white">
              <div
                className={`group flex items-center justify-between p-2 rounded-xl transition-all border ${isPayed || isCanceled ? "bg-gray-50 border-gray-100" : "bg-cyan-50/80 border-cyan-100/50 hover:bg-cyan-100 hover:border-cyan-200 cursor-pointer"}`}
                onClick={() => {
                  if (!isPayed && !isCanceled) setOpenCustomerPickerDialog(true);
                }}
              >
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  {/* Gray Avatar as per screenshot */}
                  <div className="w-10 h-10 rounded-full bg-gray-300 flex-none flex items-center justify-center text-white font-black text-lg shadow-inner ring-2 ring-white">
                    {transaction.customer?.customerGroup?.name?.[0] && (
                      <Avatar>
                        {transaction.customer?.customerGroup?.name?.[0]}
                      </Avatar>
                    )}
                  </div>

                  <div className="flex items-center gap-2 flex-1 min-w-0 text-[16px] text-slate-800 font-medium">
                    <div className="truncate flex items-center gap-1.5 leading-tight">
                      <span className="text-blue-700 font-bold whitespace-nowrap shrink-0">
                        กลุ่มลูกค้า:{" "}
                        {transaction.customer?.customerGroup?.name ||
                          "ไม่ระบุกลุ่ม"}
                      </span>
                      <span className="font-bold whitespace-nowrap">ชื่อ :</span>
                      <span className="font-black text-slate-900">
                        {transaction.customer?.shopName ||
                          transaction.customer?.name ||
                          "ไม่ระบุชื่อ"}
                      </span>
                      {transaction.customer?.shopName &&
                        transaction.customer?.name && (
                          <span className="text-slate-500">
                            ({transaction.customer.name})
                          </span>
                        )}

                      {/* Driver Name (If exists) */}
                      {transaction.driver?.name &&
                        transaction.driver.name !==
                        transaction.customer?.name && (
                          <span className="text-emerald-600 font-bold ml-1">
                            [{transaction.driver.name}{" "}
                            {transaction.driver.surname || ""}]
                          </span>
                        )}

                      {/* Vehicle Details */}
                      {(transaction.car?.carType ||
                        transaction.car?.license) && (
                          <span className="ml-2 text-slate-700 flex items-center gap-2">
                            {transaction.car?.carType} {transaction.car?.license}
                            {transaction.car?.province && (
                              <span className="text-slate-500">
                                ({transaction.car.province})
                              </span>
                            )}
                          </span>
                        )}
                      {(!isPayed && !isCanceled) && (
                        <SwitchAccountIcon className="!text-lg text-slate-300" />
                      )}
                    </div>
                  </div>

                </div>

                <div className="flex items-center gap-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!isPayed && !isCanceled) setOpenPOSelectionDialog(true);
                    }}
                    disabled={isPayed || isCanceled}
                    className="p-2 rounded-lg bg-white border border-gray-200 shadow-sm text-slate-400 hover:text-blue-600 hover:border-blue-200 transition-all active:scale-95 disabled:opacity-50"
                  >
                    <TuneIcon className="!text-lg" />
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* กล่องแสดง Items */}
          <div
            ref={scrollRef}
            className="flex-1 overflow-y-auto px-4 py-2 space-y-2 bg-gray-50/50"
          >
            {transactionBreakdown &&
              transactionBreakdown.filter(
                (item) => item.originalItem && item.originalItem.id != null,
              ).length > 0 ? (
              transactionBreakdown
                .filter(
                  (item) => item.originalItem && item.originalItem.id != null,
                )
                .map((item, index) => (
                  <div
                    key={index}
                    className="group relative bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-blue-100 transition-all overflow-hidden flex"
                  >
                    {/* Item Index / Color Bar */}
                    <div className="w-1.5 bg-blue-500/20 group-hover:bg-blue-500 transition-colors" />

                    {/* Main Content */}
                    <div
                      className={`flex-1 p-3 transition-opacity ${isPayed || isCanceled ? "opacity-90 cursor-default" : "cursor-pointer hover:bg-gray-50/50"}`}
                      onClick={() =>
                        !isPayed && !isCanceled && handleClickEdit(item?.originalItem)
                      }
                    >
                      <div className="flex justify-between items-start mb-1">
                        <div className="flex items-center gap-2">
                          <h3 className="font-black text-slate-800 text-[16px]">
                            {index + 1}. {item?.productName}
                          </h3>
                          {(!isPayed && !isCanceled) && (
                            <EditIcon className="!text-[12px] text-slate-300" />
                          )}
                        </div>

                        {/* Price Badge */}
                        {hasPermission(["show_price_in_ticket"]) && (
                          <div className="flex flex-col items-end gap-1">
                            {item?.details?.length > 0 &&
                              (() => {
                                const average =
                                  item.usedWeight > 0
                                    ? item.totalPrice / item.usedWeight
                                    : 0;
                                const basePrice =
                                  item.details[0]?.basePrice ?? 0;
                                const diff = average - basePrice;
                                const displayDiff =
                                  Math.abs(diff) < 0.005 ? 0 : diff;
                                const priceDetail =
                                  item.details.find(
                                    (detail) => detail.priceSource !== "po",
                                  ) ?? item.details[0];
                                const isInsurancePrice = item.details.some(
                                  (detail) =>
                                    detail?.isLockedPrice ||
                                    detail?.priceSource === "lock",
                                );
                                const isBasePrice =
                                  priceDetail?.priceSource === "base" ||
                                  displayDiff === 0;
                                return (
                                  <div className="relative flex items-center gap-1.5 bg-emerald-50 text-emerald-700 px-2 py-1 rounded-lg border border-emerald-100">
                                    {isAutoCategoryPricing && !isBasePrice && (
                                      <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-[9px] font-black uppercase tracking-wide text-emerald-700">
                                        ราคาขั้นบันได
                                      </span>
                                    )}
                                    {displayDiff !== 0 && (
                                      <span
                                        className={`absolute -top-3 -right-3 px-1.5 py-0.5 rounded-md text-[9px] font-black text-white shadow-sm ${displayDiff > 0 ? "bg-emerald-500" : "bg-rose-500"}`}
                                      >
                                        {displayDiff > 0 ? "+" : ""}
                                        {formatNumber(displayDiff)}
                                      </span>
                                    )}
                                    {/* Icon logic */}
                                    {(() => {
                                      if (
                                        priceDetail.isLockedPrice ||
                                        priceDetail.priceSource === "lock"
                                      )
                                        return (
                                          <LockIcon className="!text-sm" />
                                        );
                                      if (priceDetail.priceSource === "po")
                                        return (
                                          <DocumentScannerIcon className="!text-sm" />
                                        );
                                      if (priceDetail.priceSource === "base")
                                        return (
                                          <CategoryIcon className="!text-sm" />
                                        );
                                      if (priceDetail.priceSource === "custom")
                                        return (
                                          <TuneIcon className="!text-sm" />
                                        );
                                      return priceDetail.customerGroupId ? (
                                        <GroupsIcon className="!text-sm" />
                                      ) : (
                                        <CategoryIcon className="!text-sm" />
                                      );
                                    })()}
                                    {isInsurancePrice && (
                                      <span className="text-[10px] font-black text-purple-700">
                                        ประกันราคาเฉลี่ย
                                      </span>
                                    )}
                                    <span className="text-xs font-black">
                                      {formatNumber(average)}
                                    </span>
                                    <span className="text-[12px] opacity-70">
                                      บ./กก.
                                    </span>
                                  </div>
                                );
                              })()}
                          </div>
                        )}
                      </div>

                      {/* Simple Text Weights Summary */}
                      <div className="flex flex-wrap items-baseline gap-x-3 text-slate-600 text-[11px] font-medium mt-0.5">
                        <div className="flex items-center gap-1">
                          <span className="text-slate-400 text-[16px]">
                            รวมน้ำหนัก:
                          </span>
                          <span className="font-bold text-[16px]">
                            {formatNumber(item?.originalItem?.weight)}
                          </span>
                        </div>
                        <div className="flex items-center gap-1">
                          <span className="text-slate-400 text-[16px]">
                            หัก:
                          </span>
                          <span className="font-bold text-[16px]">
                            {formatNumber(item?.originalItem?.deductWeight)}
                          </span>
                        </div>
                        <div className="flex items-center gap-1">
                          <span className="text-slate-400 text-[16px]">
                            สิ่งเจือปน:
                          </span>
                          <span className="font-bold text-[16px]">
                            {formatNumber(
                              item?.originalItem?.impurityWeight +
                              (
                                item?.originalItem?.deductedItems || []
                              ).reduce((sum, d) => sum + (d.weight2 ?? 0), 0),
                            )}
                          </span>
                        </div>
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="text-slate-400 text-[16px]">=</span>
                          <span className={`text-sm font-black underline decoration-slate-200 underline-offset-4 ${Number(item?.originalItem?.netWeight) < 0 ? "text-red-500" : "text-slate-800"}`}>
                            {formatNumber(item?.originalItem?.netWeight)}
                          </span>
                        </div>
                      </div>

                      {/* Details Section (Screenshot Style) */}
                      <div className="mt-3 space-y-2">
                        {/* Highlights (Impurity & Deductions on same line if possible) */}
                        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                          {(() => {
                            const orderedDeductions =
                              getOrderedDeductionEntries(item?.originalItem);

                            if (orderedDeductions.length === 0) {
                              const legacyType =
                                item?.originalItem?.impurityType?.replace(
                                  /[()]/g,
                                  "",
                                );
                              return legacyType ? (
                                <div className="flex items-center gap-2 text-[14px]">
                                  <span className="font-black text-slate-800 shrink-0">
                                    สิ่งเจือปน
                                  </span>
                                  <span className="text-slate-600">
                                    {legacyType}
                                  </span>
                                </div>
                              ) : null;
                            }

                            return (
                              <div className="flex flex-wrap items-center gap-1.5 text-[14px]">
                                <span className="font-black text-slate-800 shrink-0 mr-1">
                                  สิ่งเจือปน
                                </span>
                                {orderedDeductions.map(
                                  ({ kind, detail }, deductionIndex) => {
                                    const isDeductedItem =
                                      kind === "deductedItem";
                                    const weight = isDeductedItem
                                      ? detail?.weight2 ?? detail?.weight
                                      : detail?.weight;
                                    const label = isDeductedItem
                                      ? detail?.productName ||
                                        detail?.title ||
                                        "สินค้าอื่น"
                                      : detail?.productName ||
                                        detail?.type ||
                                        "ไม่ระบุ";

                                    return (
                                      <div
                                        key={
                                          detail?.id ||
                                          detail?.createdAt ||
                                          `${kind}-${deductionIndex}`
                                        }
                                        className={`flex items-center gap-1 px-1.5 py-0.5 rounded-md border font-medium ${
                                          isDeductedItem
                                            ? "text-blue-600 bg-blue-50 border-blue-100"
                                            : "text-amber-700 bg-amber-50 border-amber-100"
                                        }`}
                                      >
                                        {isDeductedItem && (
                                          <span className="font-black">
                                            หักเป็น:
                                          </span>
                                        )}
                                        <span>{label}</span>
                                        <span>
                                          ({formatNumber(weight)} กก.)
                                        </span>
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                            );
                          })()}
                        </div>

                        {/* Deduct as Other (Parent Relation) */}
                        {item?.originalItem?.sourceItem && (
                          <div className="flex items-center gap-2 text-[12px] text-slate-600 bg-slate-50 p-2 rounded-lg border border-slate-100 ">
                            <DescriptionIcon className="!text-lg text-slate-800" />
                            <span className="font-medium">
                              หักเป็นสินค้าอื่น จาก{" "}
                              {item?.originalItem?.sourceItem?.productName ||
                                item?.originalItem?.sourceItem?.title}
                            </span>
                          </div>
                        )}

                        {item?.originalItem?.note && (
                          <div className="flex items-center gap-1.5 text-[11px] text-slate-500 italic px-1">
                            <DescriptionIcon className="!text-sm opacity-50" />
                            {item?.originalItem?.note}
                          </div>
                        )}
                      </div>
                      {/* PO Info */}
                      {item.details.some((d) => d.priceSource === "po") && (
                        <div className="text-[14px] font-black text-blue-600 flex items-center gap-2 flex-wrap">
                          <span>
                            สินค้านี้ใช้ราคา PO{" "}
                            {item.details
                              .filter(
                                (d) =>
                                  d.priceSource === "po" && d.poInfo?.poNumber,
                              )
                              .map(
                                (d) => `#${d.poInfo.poNumber.split("-").pop()}`,
                              )
                              .join(", ")}
                          </span>
                          {(() => {
                            const extraDetail = item.details.find(
                              (d) => d.priceSource !== "po",
                            );
                            if (!extraDetail) return null;

                            const overWeight = Number(extraDetail.usedWeight || 0);
                            const priceLabel =
                              extraDetail.priceSource === "base"
                                ? "ราคาพื้นฐาน"
                                : extraDetail.priceSource === "custom"
                                  ? "ราคากำหนดเอง"
                                  : "ราคากลุ่ม";

                            return (
                              <>
                                <span className="text-amber-500">
                                  (ส่วนเกิน {formatNumber(overWeight)} {priceLabel})
                                </span>
                              </>
                            );
                          })()}
                        </div>
                      )}

                      {/* Insurance price details */}
                      {(item?.originalItem?.isLockedPrice ||
                        item.details.some(
                          (detail) =>
                            detail?.isLockedPrice || detail?.priceSource === "lock",
                        )) && (
                        <div className="text-[14px] font-black text-purple-700 flex items-center gap-2 flex-wrap">
                          <span>สินค้านี้ใช้ ประกันราคา</span>
                          {(() => {
                            const lockDetails = item.details.filter(
                              (detail) =>
                                detail?.isLockedPrice ||
                                detail?.priceSource === "lock",
                            );
                            const extraDetails = item.details.filter(
                              (detail) =>
                                !detail?.isLockedPrice &&
                                detail?.priceSource !== "lock" &&
                                detail?.priceSource !== "po",
                            );
                            const lockedWeight = lockDetails.reduce(
                              (sum, detail) => sum + Number(detail?.usedWeight || 0),
                              0,
                            );
                            const itemWeight =
                              Number(item?.usedWeight || 0) > 0
                                ? Number(item.usedWeight)
                                : Number(item?.originalItem?.netWeight || 0);
                            const linkedLockIds = new Set(
                              (item?.originalItem?.lockItemIds ||
                                item?.originalItem?.lockPricings?.map((lock) => lock.id) ||
                                []
                              ).map(Number),
                            );
                            const linkedLocks = [
                              ...(lockItems || []),
                              ...(item?.originalItem?.lockPricings || []),
                            ]
                              .filter((lock, index, list) =>
                                linkedLockIds.has(Number(lock.id)) &&
                                list.findIndex((candidate) => Number(candidate.id) === Number(lock.id)) === index,
                              )
                              .sort(
                                (a, b) =>
                                  new Date(a.recordDate || 0).getTime() -
                                  new Date(b.recordDate || 0).getTime(),
                              );
                            let allocatedLinkedWeight = lockedWeight;
                            if (allocatedLinkedWeight <= 0 && linkedLocks.length > 0) {
                              let unallocatedWeight = itemWeight;
                              allocatedLinkedWeight = linkedLocks.reduce((sum, lock) => {
                                if (unallocatedWeight <= 0) return sum;
                                const available = Number(
                                  lock.remainingWeight ?? lock.weight ?? 0,
                                );
                                const used = Math.min(unallocatedWeight, Math.max(0, available));
                                unallocatedWeight -= used;
                                return sum + used;
                              }, 0);
                            }
                            const extraWeight = Math.max(
                              0,
                              itemWeight - allocatedLinkedWeight,
                            );
                            if (extraWeight <= 0.004) return null;
                            const extraPriceMode =
                              item?.originalItem?.insuranceExtraPriceMode ||
                              extraDetails[0]?.priceSource ||
                              "custom";
                            const extraPriceType =
                              extraPriceMode === "base"
                                ? "ราคาพื้นฐาน"
                                : extraPriceMode === "group"
                                  ? "ราคากลุ่ม"
                                  : "ราคากำหนดเอง";
                            return (
                              <span className="text-amber-600">
                                (ส่วนเกิน {formatNumber(extraWeight)} {extraPriceType})
                              </span>
                            );
                          })()}
                        </div>
                      )}

                      {hasPermission(["show_price_in_ticket"]) && (
                        <div className="mt-2 text-right">
                          <span className="text-[12px] text-slate-400 font-bold uppercase mr-1">
                            รวมเงิน
                          </span>
                          <span className={`text-[16px] font-black ${Number(item.totalPrice) < 0 ? "text-red-500" : "text-slate-800"}`}>
                            {formatNumber(item.totalPrice)}
                          </span>
                          <span className="text-xs text-slate-400 ml-1">
                            บาท
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Actions Column */}
                    <div className="flex flex-col justify-center border-l border-gray-50 bg-gray-50/20 px-1.5 gap-1.5">
                      {!isPayed && !isWeighed && !isCanceled && (
                        <button
                          onClick={() => handleDeleteItem(item.originalItem)}
                          className="p-1.5 rounded-lg text-rose-400 hover:text-rose-600 hover:bg-rose-50 transition-colors"
                        >
                          <DeleteIcon className="!text-lg" />
                        </button>
                      )}

                      {/* Image Badge */}
                      <div className="relative">
                        <button
                          onClick={() => {
                            setSelectedImage([
                              item?.originalItem?.images[
                              item?.originalItem?.images.length - 1
                              ],
                            ]);
                            setImageDetail(item?.originalItem);
                            setOpenImg(true);
                            setType("item");
                          }}
                          disabled={!item?.originalItem?.images?.length}
                          className="p-1.5 rounded-lg text-slate-400 hover:text-blue-500 hover:bg-blue-50 transition-colors disabled:opacity-30"
                        >
                          <ImageIcon className="!text-lg" />
                        </button>
                        {item?.originalItem?.images?.length > 0 && (
                          <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 bg-rose-500 text-white text-[9px] font-black rounded-full ring-2 ring-white">
                            {item?.originalItem?.images.length}
                          </span>
                        )}
                      </div>

                      {/* PO / insurance price details badge */}
                      {(item?.sources?.includes("po") ||
                        item?.originalItem?.isLockedPrice ||
                        item?.details?.some(
                          (detail) =>
                            detail?.isLockedPrice || detail?.priceSource === "lock",
                        )) && (
                        <div className="relative">
                          <button
                            onClick={() => {
                              const isPO =
                                item?.sources?.includes("po") ||
                                item?.details?.some(
                                  (detail) => detail?.priceSource === "po",
                                );
                              const isInsurance =
                                !isPO &&
                                (item?.originalItem?.isLockedPrice ||
                                  item?.details?.some(
                                    (detail) =>
                                      detail?.isLockedPrice ||
                                      detail?.priceSource === "lock",
                                  ));
                              if (isInsurance) {
                                handleOpenInsurancePriceDialog(item);
                              } else {
                                setSelectedItem(item);
                                setOpenItemDialog(true);
                              }
                            }}
                            className="p-1.5 rounded-lg text-slate-400 hover:text-emerald-500 hover:bg-emerald-50 transition-colors"
                          >
                            <ChecklistIcon className="!text-lg" />
                          </button>
                          <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 bg-emerald-500 text-white text-[9px] font-black rounded-full ring-2 ring-white">
                            {item?.details?.length}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ))
            ) : (
              <div className="flex flex-col items-center justify-center py-12 text-slate-300">
                <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-4">
                  <AddCircleOutlineIcon className="!text-3xl opacity-20" />
                </div>
                <p className="text-sm font-bold opacity-50 uppercase tracking-widest">
                  ไม่มีรายการสินค้า
                </p>
              </div>
            )}
          </div>

          {/* Column 1 Footer: Car Weights & Totals */}
          <div className="bg-white border-t border-gray-100 p-4 space-y-4">
            {/* Car Weight Card */}
            <div
              className={`p-2 rounded-xl transition-all border ${isPayed || isCanceled ? "bg-gray-50 border-gray-100 cursor-default" : "bg-slate-50 border-slate-200/60 hover:border-blue-200 cursor-pointer"}`}
              onClick={() => !isPayed && !isCanceled && setOpenCarDialog(true)}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded bg-slate-200 flex items-center justify-center text-slate-600">
                    <ScaleIcon className="!text-sm" />
                  </div>
                  <span className="font-black text-slate-800 text-[18px]">
                    น้ำหนักรถ
                  </span>
                  {(!isPayed && !isCanceled) && (
                    <EditIcon className="!text-[12px] text-slate-300" />
                  )}
                </div>

                <button
                  disabled={!hasPermission(["show_price_in_ticket"]) || isPayed || isCanceled}
                  onClick={async (e) => {
                    e.stopPropagation();
                    if (!transaction) return;
                    const isWeighed = !!transaction.weighedAt;
                    const result = await Swal.fire({
                      title: isWeighed
                        ? "ยกเลิกเวลาชั่งรถ?"
                        : "ยืนยันการชั่งรถเสร็จ?",
                      text: isWeighed
                        ? "คุณต้องการลบเวลาชั่งรถที่บันทึกไว้หรือไม่?"
                        : "ระบบจะบันทึกเวลาชั่ง ณ ตอนนี้",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: isWeighed
                        ? "ใช่, ลบเวลาออก"
                        : "ใช่, ชั่งเสร็จแล้ว",
                      cancelButtonText: "ยกเลิก",
                    });
                    if (!result.isConfirmed) return;
                    try {
                      const newValue = isWeighed ? null : new Date();
                      await services.updateTransaction(
                        { weighedAt: newValue },
                        transactionId,
                      );
                      await fetchData();
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  className={`px-3 py-1.5 rounded-xl text-xs font-black transition-all shadow-sm ${transaction?.weighedAt ? "bg-emerald-500 text-white hover:bg-emerald-600" : "bg-rose-500 text-white hover:bg-rose-600"}`}
                >
                  {transaction?.weighedAt ? "✓ ชั่งแล้ว" : "ชั่งรถเสร็จ"}
                </button>
              </div>

              <div className="grid grid-cols-[1fr_1fr_1fr_auto] gap-2">
                <div className="bg-white/60 p-2 rounded-xl border border-white shadow-sm flex items-baseline justify-between transition-all hover:bg-white/80">
                  <span className="text-[16px] text-slate-400 font-bold uppercase tracking-wider">
                    รถหนัก
                  </span>
                  <span className="text-[18px] font-black text-slate-700">
                    {formatNumber(transaction?.carHeavyWeight)}
                  </span>
                </div>
                <div className="bg-white/60 p-2 rounded-xl border border-white shadow-sm flex items-baseline justify-between transition-all hover:bg-white/80">
                  <span className="text-[16px] text-slate-400 font-bold uppercase tracking-wider">
                    รถเบา
                  </span>
                  <span className="text-[18px] font-black text-slate-700">
                    {formatNumber(transaction?.carLightWeight)}
                  </span>
                </div>
                <div className="bg-blue-50/50 p-2 rounded-xl border border-blue-100 shadow-sm flex items-center justify-between transition-all hover:bg-blue-100/30">
                  <span className="text-[16px] text-blue-400 font-bold uppercase tracking-wider">
                    สุทธิ
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="text-[18px] font-black text-blue-600">
                      {formatNumber(
                        transaction?.carHeavyWeight -
                        transaction?.carLightWeight,
                      )}
                    </span>
                  </div>
                </div>

                <div className="relative h-full">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      const carImages = transaction?.images || [];
                      if (carImages.length > 0) {
                        setSelectedImage([carImages[carImages.length - 1]]);
                        setImageDetail(transaction);
                        setOpenImg(true);
                        setType("car");
                      }
                    }}
                    disabled={!(transaction?.images?.length > 0)}
                    className={`h-full px-3 rounded-xl transition-all border flex items-center justify-center ${transaction?.images?.length > 0
                      ? "bg-white border-blue-200 text-blue-500 hover:bg-blue-50 hover:border-blue-300 shadow-sm"
                      : "bg-slate-50 border-slate-100 text-slate-300 cursor-default"
                      }`}
                  >
                    <ImageIcon className="!text-xl" />
                  </button>
                  {transaction?.images?.length > 0 && (
                    <span className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 bg-rose-500 text-white text-[10px] font-black rounded-full ring-2 ring-white shadow-sm z-10">
                      {transaction.images.length}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Weights Summary Breakdown Redesign */}
            <div className="bg-slate-50/50 rounded-xl p-3 border border-slate-100 space-y-2">
              <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
                <div className="flex items-center gap-2">
                  <span className="text-[16px] font-bold text-slate-400">
                    น้ำหนักสุทธิ
                  </span>
                  <span className="text-[18px] font-black text-slate-800">
                    {formatNumber(totalNetWeight)}{" "}
                    <span className="text-sm font-bold text-slate-400">
                      กก.
                    </span>
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-[16px] font-bold text-slate-400">
                    น้ำหนักรถ
                  </span>
                  <span className="text-[18px] font-black text-slate-800">
                    {formatNumber(
                      transaction?.carHeavyWeight - transaction?.carLightWeight,
                    )}{" "}
                    <span className="text-sm font-bold text-slate-400">
                      กก.
                    </span>
                  </span>
                  <span className="text-[16px] font-bold text-slate-400">
                    (
                    {formatNumber(
                      totalNetWeight -
                      (transaction?.carHeavyWeight -
                        transaction?.carLightWeight),
                    )}
                    )
                  </span>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-x-4 border-t border-slate-100 pt-2 text-[16px]">
                <div className="flex items-center gap-1">
                  <span className="text-slate-400">รวม:</span>
                  <span className="font-bold text-slate-700">
                    {formatNumber(totalWeight)}
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="text-slate-400">หัก:</span>
                  <span className="font-bold text-slate-700">
                    {formatNumber(totalDeductWeight)}
                  </span>
                </div>
                <div className="flex items-center gap-1 min-w-0">
                  <span className="text-slate-400">สิ่งเจือปน:</span>
                  <span className="font-bold text-slate-700 truncate">
                    {summarizeDeductions() || ""}
                  </span>
                </div>
              </div>
            </div>

            {/* Financial Summary */}
            {hasPermission(["show_price_in_ticket"]) && (
              <div className="space-y-3 bg-slate-900 rounded-3xl p-5 shadow-xl">
                <div className="flex justify-between items-center text-slate-400 text-[16px] font-bold uppercase tracking-widest px-1">
                  <div className="flex items-center gap-6">
                    <span>
                      ก่อนภาษี{" "}
                      <span className="text-white ml-2 font-black">
                        {formatNumber(beforeVat)}
                      </span>
                    </span>
                    <span className="text-slate-700 font-normal">|</span>
                    <span>
                      ภาษี (7%){" "}
                      <span className="text-rose-400 ml-2 font-black">
                        {formatNumber(vatAmt)}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center pt-3 border-t border-slate-800 px-1">
                  <span className="text-blue-400 text-[18px] font-black uppercase tracking-[0.1em]">
                    ยอดสุทธิ
                  </span>
                  <div className="flex items-baseline gap-2">
                    <span className="text-[20px] font-black text-white leading-none tracking-tight">
                      {formatNumber(grand)}
                    </span>
                    <span className="text-blue-400 text-[16px] font-black uppercase">
                      บาท
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Column: Categories, SubCategories, Product Grid, Action Pad & Notes */}
        <div className="col-span-12 lg:col-span-6 flex flex-col min-h-0 gap-4">
          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 flex flex-col flex-1 min-h-0 overflow-hidden">

            {/* Categories */}
            <div className="p-3 border-b border-gray-100 overflow-x-auto whitespace-nowrap hide-scrollbar flex gap-2">
              {categories.map((name, index) => (
                <button
                  key={index}
                  onClick={() => handleChange(name)}
                  disabled={isCanceled}
                  className={`px-6 py-3 rounded-2xl text-[18px] font-black transition-all flex border items-center justify-center shadow-sm ${filter === name
                    ? "bg-blue-600 text-white shadow-blue-200 border-blue-600"
                    : "bg-slate-50 text-slate-600 hover:bg-slate-100 border-gray-100"
                    } ${isCanceled ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  {name}
                </button>
              ))}
            </div>

            {/* SubCategories */}
            {subCategories.length > 0 && (
              <div className="px-3 py-2 border-b border-gray-50 overflow-x-auto whitespace-nowrap hide-scrollbar flex gap-2 bg-slate-50/50">
                <button
                  onClick={() => handleSubChange("ทั้งหมด")}
                  disabled={isCanceled}
                  className={`px-4 py-2 rounded-xl text-[14px] font-bold transition-all ${subFilter === "ทั้งหมด"
                    ? "bg-slate-800 text-white shadow-md"
                    : "bg-white text-slate-600 border border-slate-200 hover:bg-slate-100"
                    } ${isCanceled ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  ทั้งหมด
                </button>
                {subCategories.map((sub, index) => (
                  <button
                    key={index}
                    onClick={() => handleSubChange(sub)}
                    disabled={isCanceled}
                    className={`px-4 py-2 rounded-xl text-[14px] font-bold transition-all ${subFilter === sub
                      ? "bg-slate-800 text-white shadow-md"
                      : "bg-white text-slate-600 border border-slate-200 hover:bg-slate-100"
                      } ${isCanceled ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    {sub}
                  </button>
                ))}
              </div>
            )}

            {/* Product Grid */}
            <div className="flex-1 overflow-y-auto p-4 bg-gray-50/30">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                {displayedCards
                  .map((card) => {
                    if (isSpacerCard(card)) {
                      return (
                        <div
                          key={card.spacerId}
                          className="h-20 p-2 rounded-xl border-2 border-dashed border-slate-300 bg-slate-200/90 flex items-center justify-center text-slate-500 font-black text-lg select-none"
                        >
                          ช่องว่าง
                        </div>
                      );
                    }

                    return (
                    <button
                      key={card.productId}
                      onClick={() => !isPayed && !isWeighed && !isCanceled && handleClick(card)}
                      disabled={isPayed || isWeighed || isCanceled}
                      style={{ backgroundColor: card?.color || "#f1f5f9" }}
                      className={`h-20 p-2 rounded-xl transition-all shadow-sm hover:shadow-md text-center flex items-center justify-center group relative overflow-hidden ${(isPayed || isWeighed || isCanceled)
                        ? "opacity-40 cursor-not-allowed"
                        : "hover:scale-[1.02] active:scale-95"
                        }`}
                    >
                      <span
                        className="font-black text-[18px] z-10 leading-snug px-1 drop-shadow-sm"
                        style={{
                          color: getContrastColor(card?.color || "#f1f5f9"),
                        }}
                      >
                        {card.title}
                      </span>
                      <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </button>
                    );
                  })}
              </div>
            </div>

            {/* Action Pad Area & Notes */}
            <div className="p-4 bg-gray-50 border-t border-gray-100 flex flex-col gap-4">

              {!isLoadingBreakdown && (
                <div>
                  <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5 ml-1">
                    หมายเหตุตั๋ว
                  </label>
                  <input
                    type="text"
                    placeholder="เพิ่มหมายเหตุที่นี่..."
                    className="w-full text-sm py-3 px-4 rounded-xl border border-gray-200 bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-50 transition-all outline-none"
                    value={note || ""}
                    onChange={handleNoteChange}
                    disabled={transaction?.status === "cancel"}
                  />
                </div>
              )}

              {transaction?.status === "waiting" && (
                <div className="grid grid-cols-3 gap-3">
                  {/* Row 1 */}
                  <button
                    onClick={handleWeight}
                    disabled={applying}
                    className={`col-span-1 h-20 rounded-2xl font-black text-lg transition-all flex items-center justify-center gap-2 ${isWeighed ? "bg-emerald-600 text-white hover:bg-emerald-700" : "bg-white text-slate-900 border border-gray-200"}`}
                  >
                    {isWeighed && <CheckCircleIcon />}
                    {isWeighed ? "ชั่งเรียบร้อย" : "ชั่งเรียบร้อย"}
                  </button>

                  <button
                    onClick={handleOpenPDF}
                    disabled={!hasPermission(["Print"])}
                    className="col-span-1 h-20 bg-slate-800 text-white rounded-2xl font-black text-lg shadow-lg shadow-slate-200 hover:bg-slate-900 active:scale-95 transition-all disabled:opacity-30 border border-slate-700 flex items-center justify-center gap-2"
                  >
                    <PrintIcon />
                    พิมพ์ A4
                  </button>

                  <button
                    onClick={handlePayed}
                    disabled={!hasPermission(["purchase_pay_all"])}
                    className="col-span-1 h-20 bg-blue-600 text-white rounded-2xl font-black text-lg shadow-lg shadow-blue-100 hover:bg-blue-700 active:scale-95 transition-all disabled:opacity-30 flex flex-col items-center justify-center"
                  >
                    จ่ายเงิน
                  </button>

                  {/* Row 2 */}
                  <div className="col-span-3 grid grid-cols-4 gap-3">
                    <button
                      onClick={() => setOpenTransactionDialog(true)}
                      className="col-span-1 h-14 bg-amber-50 text-amber-600 border border-amber-200 rounded-2xl font-black text-sm hover:bg-amber-100 active:scale-95 transition-all flex items-center justify-center shadow-sm"
                    >
                      <AssignmentIcon className="mr-1 !text-lg" />
                      สรุป PO
                    </button>

                    <button
                      onClick={handleApplyBestPrice}
                      disabled={
                        applying ||
                        !isWeighed ||
                        !hasPermission(["show_price_in_ticket"])
                      }
                      className="col-span-1 h-14 bg-white text-emerald-600 border border-gray-200 rounded-2xl font-black text-sm hover:bg-emerald-50 active:scale-95 transition-all disabled:opacity-30 disabled:text-emerald-300 flex items-center justify-center shadow-sm"
                    >
                      คำนวณราคาดีสุด
                    </button>

                    <button
                      onClick={() => (window.location.href = "/buy")}
                      className="col-span-1 h-14 bg-white text-slate-800 rounded-2xl font-black text-sm border border-gray-200 hover:bg-gray-50 active:scale-95 transition-all shadow-sm"
                    >
                      ปิดหน้าตั๋ว
                    </button>

                    <button
                      onClick={() => handleUpdate("cancel")}
                      disabled={!hasPermission(["purchase_cancel_ticket"])}
                      className="col-span-1 h-14 bg-rose-50 text-rose-500 rounded-2xl font-black text-sm border border-rose-100 hover:bg-rose-100 transition-all disabled:opacity-30 shadow-sm"
                    >
                      ยกเลิกตั๋ว
                    </button>
                  </div>
                </div>
              )}

              {isPayed && (
                <div className="flex flex-col gap-3">
                  <div className="grid grid-cols-3 gap-3">
                    <div className="col-span-1 h-20 bg-gray-100 text-gray-400 rounded-2xl font-black flex items-center justify-center text-sm uppercase tracking-widest border border-gray-200">
                      จ่ายแล้ว
                    </div>
                    <button
                      onClick={handleOpenPDF}
                      className="col-span-1 h-20 bg-slate-800 text-white rounded-2xl font-black text-lg shadow-lg hover:bg-slate-900 active:scale-95 transition-all"
                    >
                      พิมพ์ A4
                    </button>
                    <button
                      disabled
                      className="col-span-1 h-20 bg-gray-100 text-gray-400 rounded-2xl font-black flex items-center justify-center text-sm uppercase tracking-widest border border-gray-200"
                    >
                      จ่าย
                    </button>
                  </div>

                  <div className="grid grid-cols-3 gap-3">
                    <button
                      onClick={() => setOpenTransactionDialog(true)}
                      className="col-span-1 h-14 bg-amber-50 text-amber-600 border border-amber-200 rounded-2xl font-black text-sm hover:bg-amber-100 active:scale-95 transition-all flex items-center justify-center shadow-sm"
                    >
                      <AssignmentIcon className="mr-1 !text-lg" />
                      สรุป PO
                    </button>
                    <button
                      onClick={() => (window.location.href = "/buy")}
                      className="col-span-1 h-14 bg-white text-slate-800 rounded-2xl font-black text-sm border border-gray-200 hover:bg-gray-50 transition-all"
                    >
                      ปิดหน้าตั๋ว
                    </button>
                    <button
                      onClick={() => handleUpdate("waiting")}
                      disabled={!hasPermission(["purchase_cancel_payment"])}
                      className="col-span-1 h-14 bg-rose-50 text-rose-500 rounded-2xl font-black text-sm border border-rose-100 hover:bg-rose-100 transition-all"
                    >
                      ยกเลิกจ่ายเงิน
                    </button>
                  </div>
                </div>
              )}

              {transaction?.status === "cancel" && (
                <div className="flex gap-3">
                  <button
                    onClick={() => handleUpdate("uncancel")}
                    disabled={!hasPermission(["purchase_pay_all"])}
                    className="flex-1 bg-rose-50 text-rose-500 p-4 rounded-2xl border border-rose-100 font-black text-center uppercase tracking-widest hover:bg-rose-100 transition-all disabled:opacity-30 shadow-sm"
                  >
                    ยกเลิกการยกเลิกบิล
                  </button>
                  <button
                    onClick={() => (window.location.href = "/buy")}
                    className="w-1/3 h-full bg-white text-slate-800 rounded-2xl font-black border border-gray-200 hover:bg-gray-50"
                  >
                    ปิดหน้าตั๋ว
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <POSelectionDialog
        open={openPOSelectionDialog}
        onClose={() => setOpenPOSelectionDialog(false)}
        transaction={transaction}
        poSelect={poSelect}
        lockSelect={lockSelect}
        onSubmit={async ({ type, po, lock, dateRange }) => {
          try {
            if (type === "po") {
              setLockSelect([]);
              const clearedLockItems = (transaction?.items || [])
                .filter((item) => item?.id)
                .map((item) => ({
                  id: item.id,
                  lockItemIds: [],
                  insuranceExtraPrice: null,
                  insuranceExtraPriceMode: null,
                  poExtraPriceMode: null,
                  poExtraCustomPrice: null,
                  isLockedPrice: false,
                }));
              const poUsageJson = (po || [])
                .flatMap((p) =>
                  Array.isArray(p.items)
                    ? p.items.map((it) => ({ p, it }))
                    : [],
                )
                .map(({ p, it }) => ({
                  poId: p.id,
                  poItemId: it.id,
                  total: N(it.poWeight),
                  usedWeight: 0,
                  purchasePrice: N(it.purchasePrice),
                  poNumber: p.poNumber,
                }));

              await services.updateTransaction(
                { poUsageJson, isLock: false, items: clearedLockItems },
                transactionId,
              );
            } else if (type === "lock") {
              const selectedLocks = (lock || []).filter(
                (item) =>
                  String(item?.master?.status || "").toUpperCase() ===
                  "APPROVED" && item.specialPrice != null,
              );
              const locksByProduct = new Map();
              selectedLocks.forEach((item) => {
                const key = getLockSellProductId(item);
                if (!locksByProduct.has(key)) locksByProduct.set(key, []);
                locksByProduct.get(key).push(item);
              });
              locksByProduct.forEach((items) =>
                items.sort((a, b) => new Date(a.recordDate) - new Date(b.recordDate))
              );
              const updatedItems = (transaction?.items || []).map((item) => {
                const locks = locksByProduct.get(Number(item.productId)) || [];
                let remainingWeight = N(item.netWeight ?? item.weight);
                let totalPrice = 0;
                let lockedWeight = 0;
                const itemAllocations = [];
                for (const lock of locks) {
                  if (remainingWeight <= 0) break;
                  const available = N(lock.remainingWeight ?? lock.weight);
                  const used = Math.min(remainingWeight, available);
                  if (used <= 0) continue;
                  itemAllocations.push(Number(lock.id));
                  lockedWeight += used;
                  totalPrice += used * N(lock.specialPrice);
                  remainingWeight -= used;
                }
                if (!lockedWeight) {
                  return {
                    id: item.id,
                    lockItemIds: [],
                    insuranceExtraPrice: null,
                    insuranceExtraPriceMode: null,
                    poExtraPriceMode: null,
                    poExtraCustomPrice: null,
                    isLockedPrice: false,
                  };
                }
                const price = totalPrice / lockedWeight;
                return {
                  id: item.id,
                  pricePerUnit: price,
                  netPrice: N(item.netWeight ?? item.weight) * price,
                  isLockedPrice: true,
                  lockItemIds: itemAllocations,
                  insuranceExtraPrice: null,
                  insuranceExtraPriceMode: null,
                  poExtraPriceMode: null,
                  poExtraCustomPrice: null,
                };
              });
              setLockSelect(selectedLocks);
              await services.updateTransaction(
                { poUsageJson: [], isLock: true, items: updatedItems },
                transactionId,
              );
            } else {
              setLockSelect([]);
              const clearedLockItems = (transaction?.items || [])
                .filter((item) => item?.id)
                .map((item) => ({
                  id: item.id,
                  lockItemIds: [],
                  insuranceExtraPrice: null,
                  insuranceExtraPriceMode: null,
                  poExtraPriceMode: null,
                  poExtraCustomPrice: null,
                  isLockedPrice: false,
                }));
              await services.updateTransaction(
                { poUsageJson: [], isLock: false, items: clearedLockItems },
                transactionId,
              );
            }

            await fetchData();

            toast.success("บันทึกข้อมูลเรียบร้อย!");
          } catch (err) {
            console.error("บันทึก poUsageJson ล้มเหลว:", err);
            toast.error("เกิดข้อผิดพลาดระหว่างบันทึกข้อมูล");
          }
        }}
      />

      <POBreakdownGrid
        open={openTransactionDialog}
        onClose={() => setOpenTransactionDialog(false)}
        poData={transactionBreakdown}
        transaction={transaction}
        allPoItems={poItems}
        poUsageJson={transaction?.poUsageJson}
        onOpenExtraPrice={handleOpenPOExtraPriceDialog}
      />

      <CustomerPickerDialog
        open={openCustomerPickerDialog}
        onClose={() => setOpenCustomerPickerDialog(false)}
        showCreateButton
        onSuccess={handleChangeCustomer}
        selectedCustomerId={transaction?.customerId ?? transaction?.customer?.id ?? null}
      />

      <ImageModal
        open={openImg}
        onClose={() => setOpenImg(false)}
        imageDetail={imageDetail}
        selectedImage={selectedImage}
        type={type}
      />

      <ProductFormDialog
        key={`${transactionId}-${selectedValue?.itemId ?? selectedValue?.id ?? "new"}`}
        selectedValue={selectedValue}
        transaction={transaction}
        customer={transaction?.customer}
        lockItems={lockItems}
        open={openProductDialog}
        onClose={handleClose}
        onSubmit={handleSubmit}
        isWeighed={isWeighed}
      />

      <WeightDialog
        transaction={transaction}
        open={openCarDialog}
        onClose={() => setOpenCarDialog(false)}
        onConfirm={handleConfirm}
      />

      <PaymentDialog
        open={openPaymentMethod}
        onClose={async () => {
          setOpenPaymentMethod(false);
          await fetchData();
        }}
        onSelect={handleSelectMethod}
      />

      <ItemTableModal
        open={openItemDialog}
        onClose={() => {
          setOpenItemDialog(false);
          setSelectedItem(null);
        }}
        item={selectedItem}
        onOpenExtraPrice={handleOpenPOExtraPriceDialog}
      />

      <POExtraPriceDialog
        open={openPOExtraPriceDialog}
        onClose={() => {
          setOpenPOExtraPriceDialog(false);
          setSelectedPOExtraItem(null);
        }}
        item={selectedPOExtraItem}
        onSave={handleSavePOExtraPrice}
      />

      <InsurancePriceDetailModal
        open={openInsurancePriceDialog}
        onClose={() => {
          setOpenInsurancePriceDialog(false);
          setSelectedInsuranceItem(null);
        }}
        item={selectedInsuranceItem}
        lockItems={lockItems}
        onSave={handleSaveInsurancePrice}
      />
    </div >
  );
};

export default Page;
